export default {
  'pages.account.settings.apiKey.column.ipWhitelist': 'IP 白名单',
  'pages.account.settings.apiKey.createSubtitle':
    '为应用生成专属 API Key,Secret 仅在创建时显示一次',
  'pages.account.settings.apiKey.form.ipWhitelist': 'IP 白名单(可选)',
  'pages.account.settings.apiKey.form.ipWhitelist.add': '添加 IP 地址',
  'pages.account.settings.apiKey.form.ipWhitelist.hint':
    '不填写则不限制 IP,填写后仅允许白名单内的 IP 使用此 Key',
  'pages.account.settings.apiKey.form.ipWhitelist.invalid':
    '请输入有效的 IP 地址',
  'pages.account.settings.apiKey.hideSecret': '隐藏',
  'pages.account.settings.apiKey.ipWhitelist.all': '不限制',
  'pages.account.settings.apiKey.showSecret': '显示',
  'pages.account.settings.avatar.change': '更换',
  'pages.account.settings.avatar.hint': '支持 JPG、PNG 格式,最大 10MB',
  'pages.account.settings.group.account': '账户',
  'pages.account.settings.group.api': '调用与配额',
  'pages.account.settings.group.devices': '设备',
  'pages.account.settings.section.accountInfo': '账户信息',
  'pages.account.settings.section.personalInfo': '个人信息',
  'pages.account.settings.security.email.boundStatus': '已绑定',
  'pages.account.settings.security.email.unboundStatus': '未绑定',
  'pages.account.settings.sessions.earliestLogin': '最早登录 {time}',
  'pages.account.settings.sessions.groupCount': '{count} 个会话',
  'pages.account.settings.sessions.lastActive': '最后活跃 {time}',
  'pages.account.settings.sessions.loggedInAt': '登录于 {time}',
  'pages.account.settings.sessions.revokeGroupConfirm':
    '确定要下线此设备的 {count} 个会话吗?',
  'pages.account.settings.sessions.revokeGroupSuccess': '已下线 {count} 个会话',
  'pages.adminTasks.colUser': '用户',
  'pages.adminTasks.title': '全局任务管理',
  'pages.assets.title': '用户资产',
  'pages.assets.totalCount': '共 {n} 项',
  'pages.monitor.minio.buckets': 'Bucket',
  'pages.monitor.minio.col.bucketName': '名称',
  'pages.monitor.minio.col.objects': '对象数',
  'pages.monitor.minio.col.size': '大小',
  'pages.monitor.minio.disabled': '未配置',
  'pages.monitor.minio.lastUpdate': '更新于 {t}',
  'pages.monitor.minio.nodes': '节点',
  'pages.monitor.minio.refresh': '刷新',
  'pages.monitor.minio.summary':
    '可用 {free} · {objects} 对象 · {buckets} bucket · {nodes} 节点',
  'pages.monitor.minio.title': 'MinIO 集群',
  'pages.monitor.minio.uptime': '已运行 {t}',
  'pages.users.detail.basicInfo': '基本信息',
  'pages.users.detail.login.device': '设备',
  'pages.users.detail.login.empty': '无登录记录',
  'pages.users.detail.login.failed': '失败',
  'pages.users.detail.login.filter.all': '全部',
  'pages.users.detail.login.location': '位置',
  'pages.users.detail.login.method': '方式',
  'pages.users.detail.login.status': '结果',
  'pages.users.detail.login.success': '成功',
  'pages.users.detail.login.time': '时间',
  'pages.users.detail.login.title': '登录历史',
  'pages.users.detail.login.total': '共 {n} 条',
  'pages.users.detail.session.device': '设备',
  'pages.users.detail.session.empty': '当前无活跃会话',
  'pages.users.detail.session.lastActive': '最近活跃',
  'pages.users.detail.session.location': '位置',
  'pages.users.detail.session.loginAt': '登录时间',
  'pages.users.detail.session.title': '当前活跃会话',
  'pages.users.detail.session.total': '{n} 个设备在线',
  'pages.users.detail.tab.access': '访问/设备',
  'pages.users.detail.tab.assets': '资产',
  'pages.users.detail.tab.info': '基本信息',
  'pages.users.detail.tab.loginHistory': '登录历史',
  'pages.users.detail.tab.tasks': '请求记录',

  'pages.layouts.userLayout.title': '',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage':
    '邮箱或密码错误',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.password.placeholder': '请输入密码',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.emailLogin.tab': '邮箱登录',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号',
  'pages.login.phoneSendCode': '发送验证码',
  'pages.login.phoneCodeSent': '验证码已发送到您的手机',
  'pages.login.phoneCodeSentTo': '验证码已发送到',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.brand.title': 'Genvas - Generate Canvas',
  'pages.login.brand.subtitle':
    'Build with AI canvas, Generate Images, Voices and Videos',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.title': '页面未找到',
  'pages.404.subTitle': '抱歉，您访问的页面不存在或已被移除。',
  'pages.404.backText': '返回上一页',
  'pages.404.buttonText': '返回首页',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',

  // 登录页面
  'pages.login.headerTitle': '欢迎回来',
  'pages.login.headerSubtitle': '使用邮箱登录到 Genvas Admin',
  'pages.login.headerVerifyTitle': '验证邮箱',
  'pages.login.headerVerifySubtitle': '请输入收到的 6 位验证码以完成登录',
  'pages.login.email.label': '邮箱',
  'pages.login.password.label': '密码',
  'pages.login.captcha.label': '验证码',
  'pages.login.email.placeholder': '请输入邮箱',
  'pages.login.email.required': '请输入邮箱！',
  'pages.login.email.invalid': '邮箱格式不正确！',
  'pages.login.noAccount': '还没有账号？',
  'pages.login.register': '立即注册',
  'pages.login.googleLogin': '使用 Google 账号登录',
  'pages.login.googleSuccess': 'Google 登录成功',
  'pages.login.googleFailed': 'Google 登录失败',
  'pages.login.codeSent': '验证码已发送到您的邮箱',
  'pages.login.codeResent': '验证码已重新发送',
  'pages.login.sendCodeFailed': '发送验证码失败',
  'pages.login.requestFailed': '登录请求失败，请重试',
  'pages.login.verifyFailed': '验证失败，请重试',
  'pages.login.verify': '验证',
  'pages.login.codeSentTo': '验证码已发送到',
  'pages.login.resendAfter': '{count} 秒后重发',
  'pages.login.resend': '重新发送',
  'pages.login.captcha.length': '验证码为6位数字',
  'pages.login.googleLoginSuccess': 'Google 登录成功',
  'pages.login.googleLoginFailed': 'Google 登录失败',
  'pages.login.verificationCodeSent': '验证码已发送到您的邮箱',
  'pages.login.verificationCodeFailed': '发送验证码失败，请重试',
  'pages.login.countdownText': '秒后可重发',
  'pages.login.reLogin': '重新登录',

  // 注册弹窗
  'pages.register.title': '注册账号',
  'pages.register.nickname.required': '请输入昵称!',
  'pages.register.nickname.length': '昵称长度为1-50个字符',
  'pages.register.nickname.placeholder': '1-50个字符',
  'pages.register.email': '邮箱',
  'pages.register.email.required': '请输入邮箱地址!',
  'pages.register.email.invalid': '邮箱地址格式错误!',
  'pages.register.email.placeholder': '请输入邮箱',
  'pages.register.nickname': '昵称',
  'pages.register.optional': '可选',
  'pages.register.password': '密码',
  'pages.register.password.required': '请输入密码!',
  'pages.register.password.minLength': '密码至少6个字符',
  'pages.register.password.placeholder': '至少 8 位，含字母和数字',
  'pages.register.password.strong': '强度：强',
  'pages.register.password.medium': '强度：中',
  'pages.register.password.weak': '强度：太短',
  'pages.register.password.hint': '请至少输入 6 个字符',
  'pages.register.password.mismatch': '两次输入的密码不匹配!',
  'pages.register.confirmPassword': '确认密码',
  'pages.register.confirmPassword.required': '请确认密码',
  'pages.register.confirmPassword.placeholder': '再次输入密码',
  'pages.register.referralCode': '推荐码',
  'pages.register.submit': '注册',
  'pages.register.codeSent': '验证码已发送到您的邮箱',
  'pages.register.requestFailed': '注册请求失败，请重试',
  'pages.register.codeSentTo': '验证码已发送到',
  'pages.register.modifyInfo': '修改信息',
  'pages.register.code.required': '请输入验证码!',
  'pages.register.code.length': '验证码为6位数字',
  'pages.register.code.placeholder': '6位验证码',
  'pages.register.resend': '重新发送',
  'pages.register.resendAfter': '{count} 秒后重发',
  'pages.register.password.rule': '密码至少 8 位，需同时包含字母和数字',
  'pages.register.haveAccount': '已有账号？',
  'pages.register.toLogin': '返回登录',
  'pages.register.headerTitle': '注册账号',
  'pages.register.headerSubtitle': '创建你的 Genvas 账号',
  'pages.register.headerVerifyTitle': '验证邮箱',
  'pages.register.headerVerifySubtitle': '请输入收到的 6 位验证码以完成注册',
  'pages.register.verifyAndRegister': '验证并注册',
  'pages.register.success': '注册成功！',
  'pages.register.verifyFailed': '验证失败，请重试',
  'pages.register.codeResent': '验证码已重新发送',
  'pages.register.sendCodeFailed': '发送验证码失败',

  // 忘记密码弹窗
  'pages.forgotPassword.title': '找回密码',
  'pages.forgotPassword.step1': '验证邮箱',
  'pages.forgotPassword.step2': '验证码',
  'pages.forgotPassword.step3': '重置密码',
  'pages.forgotPassword.email': '注册邮箱',
  'pages.forgotPassword.email.required': '请输入邮箱地址',
  'pages.forgotPassword.email.invalid': '邮箱格式不正确',
  'pages.forgotPassword.email.placeholder': '请输入注册邮箱',
  'pages.forgotPassword.sendCode': '发送验证码',
  'pages.forgotPassword.codeSent': '验证码已发送到您的邮箱',
  'pages.forgotPassword.sendFailed': '发送验证码失败，请重试',
  'pages.forgotPassword.codeSentTo': '验证码已发送到',
  'pages.forgotPassword.code.required': '请输入验证码',
  'pages.forgotPassword.code.length': '验证码为6位数字',
  'pages.forgotPassword.code.placeholder': '6位验证码',
  'pages.forgotPassword.resend': '重新发送',
  'pages.forgotPassword.resendAfter': '{count} 秒后重发',
  'pages.forgotPassword.changeEmail': '修改邮箱',
  'pages.forgotPassword.backToLoginLink': '返回登录',
  'pages.forgotPassword.newPassword.rule':
    '密码至少 8 位，需同时包含字母和数字',
  'pages.forgotPassword.headerTitle': '找回密码',
  'pages.forgotPassword.headerSubtitle':
    '通过邮箱验证码重置你的 Genvas 账号密码',
  'pages.forgotPassword.next': '下一步',
  'pages.forgotPassword.newPassword': '新密码',
  'pages.forgotPassword.newPassword.required': '请输入新密码',
  'pages.forgotPassword.newPassword.minLength': '密码至少6个字符',
  'pages.forgotPassword.newPassword.placeholder': '至少 8 位，含字母和数字',
  'pages.forgotPassword.confirmPassword': '确认新密码',
  'pages.forgotPassword.confirmPassword.required': '请确认新密码',
  'pages.forgotPassword.confirmPassword.placeholder': '再次输入新密码',
  'pages.forgotPassword.passwordMismatch': '两次输入的密码不匹配!',
  'pages.forgotPassword.resetPassword': '重置密码',
  'pages.forgotPassword.resetSuccess': '密码重置成功！',
  'pages.forgotPassword.resetFailed': '重置密码失败，请重试',
  'pages.forgotPassword.successTitle': '密码重置成功',
  'pages.forgotPassword.successSubtitle': '请使用新密码登录',
  'pages.forgotPassword.backToLogin': '返回登录',
  'pages.forgotPassword.codeResent': '验证码已重新发送',
  'pages.forgotPassword.sendCodeFailed': '发送验证码失败',

  // 用户管理页面
  'pages.userManage.title': '用户列表',
  'pages.userManage.column.user': '用户',
  'pages.userManage.column.nickname': '昵称',
  'pages.userManage.column.email': '邮箱',
  'pages.userManage.column.roles': '角色',
  'pages.userManage.column.createdAt': '注册时间',
  'pages.userManage.column.lastLogin': '最近操作',
  'pages.userManage.column.status': '状态',
  'pages.userManage.column.action': '操作',
  'pages.userManage.search': '搜索',
  'pages.userManage.search.placeholder': '邮箱/昵称/用户ID',
  'pages.userManage.status.active': '正常',
  'pages.userManage.status.banned': '已禁用',
  'pages.userManage.status.placeholder': '选择状态',
  'pages.userManage.role.admin': '管理员',
  'pages.userManage.role.agent': '代理',
  'pages.userManage.role.referral': '推荐人',
  'pages.userManage.role.user': '用户',
  'pages.userManage.role.normalUser': '普通用户',
  'pages.userManage.role.placeholder': '选择角色',
  'pages.userManage.action.detail': '详情',
  'pages.userManage.action.disable': '禁用',
  'pages.userManage.action.enable': '启用',
  'pages.userManage.action.manageRoles': '管理角色',
  'pages.userManage.action.save': '保存',
  'pages.userManage.action.cancel': '取消',
  'pages.userManage.action.confirmDisable': '确认禁用',
  'pages.userManage.emailNotVerified': '未验证',
  'pages.userManage.emailVerified': '已验证',
  'pages.userManage.copied': '已复制',
  'pages.userManage.stats.totalUsers': '用户总数',
  'pages.userManage.stats.activeUsers': '活跃用户',
  'pages.userManage.stats.verifiedUsers': '已验证',
  'pages.userManage.stats.recentUsers': '近7天注册',
  'pages.userManage.stats.recentActiveUsers': '近7天活跃',
  'pages.userManage.detail.title': '用户详情',
  'pages.userManage.detail.basicInfo': '基本信息',
  'pages.userManage.detail.userId': '用户ID',
  'pages.userManage.detail.emailVerified': '邮箱验证',
  'pages.userManage.detail.nickname': '昵称',
  'pages.userManage.detail.loginMethods': '登录方式',
  'pages.userManage.detail.referralCode': '推荐码',
  'pages.userManage.detail.loadFailed': '获取用户详情失败',
  'pages.userManage.detail.operationFailed': '操作失败',
  'pages.userManage.detail.userBanned': '用户已禁用',
  'pages.userManage.detail.userEnabled': '用户已启用',
  'pages.userManage.detail.rolesUpdated': '角色更新成功',
  'pages.userManage.detail.rolesUpdateFailed': '角色更新失败',
  'pages.userManage.detail.userNotFound': '用户不存在',
  'pages.userManage.confirm.banUser': '确定禁用该用户？',
  'pages.userManage.confirm.banUserDesc': '禁用后用户将无法登录',
  'pages.userManage.confirm.enableUser': '确定启用该用户？',
  'pages.userManage.confirm.enable': '确定启用？',
  'pages.userManage.apiKey.name': '名称',
  'pages.userManage.apiKey.disabled': 'API Key 已禁用',
  'pages.userManage.apiKey.enabled': 'API Key 已启用',
  'pages.userManage.apiKey.statusDisabled': '禁用',
  'pages.userManage.modal.manageRoles': '管理用户角色',
  'pages.userManage.modal.selectRoles': '选择角色',
  'pages.userManage.modal.rolesHint':
    '提示：修改角色后，用户需要重新登录才能生效。',
  'pages.userManage.modal.disableApiKey': '禁用 API Key',
  'pages.userManage.modal.disableApiKeyConfirm': '确定要禁用以下 API Key 吗？',
  'pages.userManage.modal.disableReasonPlaceholder': '请输入禁用原因（可选）',

  // 用户会话管理（管理员）
  'pages.userManage.sessions.title': '会话管理',
  'pages.userManage.sessions.description': '管理该用户当前登录的设备',
  'pages.userManage.sessions.historyDeprojection': '查看该用户的登录历史记录',
  'pages.userManage.sessions.tab.devices': '登录设备',
  'pages.userManage.sessions.tab.history': '登录历史',
  'pages.userManage.sessions.loadFailed': '加载失败',
  'pages.userManage.sessions.empty': '暂无会话',
  'pages.userManage.sessions.historyEmpty': '暂无登录记录',
  'pages.userManage.sessions.total': '共 {total} 个设备',
  'pages.userManage.sessions.historyTotal': '共 {total} 条记录',
  'pages.userManage.sessions.revokeAll': '强制下线所有设备',
  'pages.userManage.sessions.revokeAllTitle': '强制下线所有设备',
  'pages.userManage.sessions.revokeAllContent':
    '确定要强制下线该用户的所有设备吗？此操作不可撤销。',
  'pages.userManage.sessions.revokeAllSuccess': '已下线 {count} 个设备',
  'pages.userManage.sessions.revokeAllFailed': '下线失败',
  'pages.userManage.sessions.revokeConfirm': '确定要下线此设备吗？',
  'pages.userManage.sessions.revokeSuccess': '会话已撤销',
  'pages.userManage.sessions.revokeFailed': '撤销失败',
  'pages.userManage.sessions.revoke': '下线',
  'pages.userManage.sessions.confirm': '确定',
  'pages.userManage.sessions.cancel': '取消',
  'pages.userManage.sessions.search': '查询',
  'pages.userManage.sessions.filterStatus': '筛选状态',
  'pages.userManage.sessions.column.device': '设备',
  'pages.userManage.sessions.column.location': '位置',
  'pages.userManage.sessions.column.loginMethod': '登录方式',
  'pages.userManage.sessions.column.lastActive': '最后活跃',
  'pages.userManage.sessions.column.action': '操作',
  'pages.userManage.sessions.column.time': '时间',
  'pages.userManage.sessions.column.status': '状态',
  'pages.userManage.sessions.device.desktop': '桌面端',
  'pages.userManage.sessions.device.mobile': '移动端',
  'pages.userManage.sessions.device.tablet': '平板',
  'pages.userManage.sessions.device.unknown': '未知',
  'pages.userManage.sessions.loginMethod.password': '密码登录',
  'pages.userManage.sessions.loginMethod.google': 'Google 登录',
  'pages.userManage.sessions.loginMethod.apikey': 'API Key',
  'pages.userManage.sessions.status.success': '成功',
  'pages.userManage.sessions.status.failed': '失败',

  // 用户充提记录
  'pages.userManage.transactions.title': '充提记录',
  'pages.userManage.transactions.description': '查看该用户的充值和提现记录',
  'pages.userManage.transactions.empty': '暂无充提记录',
  'pages.userManage.transactions.total': '共 {total} 条记录',
  'pages.userManage.transactions.loadFailed': '加载充提记录失败',

  // 用户资产余额
  'pages.userManage.balance.title': '资产余额',
  'pages.userManage.balance.empty': '暂无资产数据',
  'pages.userManage.balance.available': '可用',
  'pages.userManage.balance.frozen': '冻结',
  'pages.userManage.balance.adjust': '调整',
  'pages.userManage.balance.adjustTitle': '调整用户余额',
  'pages.userManage.balance.currentBalance': '当前余额',
  'pages.userManage.balance.adjustAmount': '调整金额',
  'pages.userManage.balance.adjustAmount.required': '请输入调整金额',
  'pages.userManage.balance.adjustAmount.notZero': '调整金额不能为0',
  'pages.userManage.balance.adjustAmount.hint': '正数增加余额，负数减少余额',
  'pages.userManage.balance.adjustAmount.placeholder': '如 100 或 -50',
  'pages.userManage.balance.adjustRemark': '调整原因',
  'pages.userManage.balance.adjustRemark.required': '请输入调整原因',
  'pages.userManage.balance.adjustRemark.placeholder':
    '请输入调整原因，如：管理员手动充值',
  'pages.userManage.balance.confirmAdjust': '确认调整',
  'pages.userManage.balance.adjustSuccess': '余额调整成功，新余额：{balance}',
  'pages.userManage.balance.adjustFailed': '余额调整失败',

  // 用户交易记录
  'pages.userManage.history.title': '交易记录',
  'pages.userManage.history.description': '查看该用户的所有交易记录',
  'pages.userManage.history.empty': '暂无交易记录',
  'pages.userManage.history.total': '共 {total} 条记录',
  'pages.userManage.history.loadFailed': '加载交易记录失败',
  'pages.userManage.history.column.type': '类型',
  'pages.userManage.history.type.deposit': '充值',
  'pages.userManage.history.type.withdrawal': '提现',
  'pages.userManage.history.type.internal_transfer': '内部转账',
  'pages.userManage.history.type.internal_deposit': '内部充值',

  // 用户卡片管理 (UserDetailModal)
  'pages.userManage.cards.title': '用户卡片',
  'pages.userManage.cards.description': '查看该用户的所有卡片',
  'pages.userManage.cards.empty': '暂无卡片',
  'pages.userManage.cards.total': '共 {total} 张卡片',
  'pages.userManage.cards.loadDetailFailed': '加载详情失败',
  'pages.userManage.cards.loadTransactionsFailed': '加载交易记录失败',
  'pages.userManage.cards.noChanges': '没有修改任何内容',
  'pages.userManage.cards.updateSuccess': '更新成功',
  'pages.userManage.cards.updateFailed': '更新失败',
  'pages.userManage.cards.column.cardNumber': '卡号',
  'pages.userManage.cards.column.holderName': '持卡人',
  'pages.userManage.cards.column.cardOrg': '卡组织',
  'pages.userManage.cards.column.balance': '余额',
  'pages.userManage.cards.column.status': '状态',
  'pages.userManage.cards.column.createdAt': '开卡时间',
  'pages.userManage.cards.column.action': '操作',
  'pages.userManage.cards.status.active': '正常',
  'pages.userManage.cards.status.frozen': '冻结',
  'pages.userManage.cards.status.cancelled': '已注销',
  'pages.userManage.cards.action.detail': '详情',
  'pages.userManage.cards.action.transactions': '记录',
  'pages.userManage.cards.action.edit': '编辑',
  'pages.userManage.cards.detail.title': '卡片详情',
  'pages.userManage.cards.detail.basicInfo': '基本信息',
  'pages.userManage.cards.detail.sensitiveInfo': '敏感信息',
  'pages.userManage.cards.detail.showSensitive': '显示',
  'pages.userManage.cards.detail.hideSensitive': '隐藏',
  'pages.userManage.cards.detail.fullCardNumber': '完整卡号',
  'pages.userManage.cards.detail.expireDate': '过期日期',
  'pages.userManage.cards.detail.clickToShow': '点击上方按钮显示敏感信息',
  'pages.userManage.cards.transactions.title': '卡片交易记录',
  'pages.userManage.cards.transactions.total': '共 {total} 条记录',
  'pages.userManage.cards.transactions.column.time': '时间',
  'pages.userManage.cards.transactions.column.type': '类型',
  'pages.userManage.cards.transactions.column.amount': '金额',
  'pages.userManage.cards.transactions.column.fee': '手续费',
  'pages.userManage.cards.transactions.column.balance': '余额变化',
  'pages.userManage.cards.transactions.column.merchant': '商户',
  'pages.userManage.cards.transactions.type.recharge': '充值',
  'pages.userManage.cards.transactions.type.withdraw': '提现',
  'pages.userManage.cards.transactions.type.payment': '消费',
  'pages.userManage.cards.transactions.type.refund': '退款',
  'pages.userManage.cards.edit.title': '编辑卡片',
  'pages.userManage.cards.edit.sensitiveFields': '敏感信息（可选）',
  'pages.userManage.cards.edit.leaveEmptyNoChange': '留空表示不修改',

  // 管理员用户卡片管理页面
  'pages.adminUserCards.title': '用户卡片管理',
  'pages.adminUserCards.loadDetailFailed': '加载详情失败',
  'pages.adminUserCards.loadTransactionsFailed': '加载交易记录失败',
  'pages.adminUserCards.noChanges': '没有修改任何内容',
  'pages.adminUserCards.updateSuccess': '更新成功',
  'pages.adminUserCards.updateFailed': '更新失败',
  'pages.adminUserCards.copied': '{field} 已复制',
  'pages.adminUserCards.stats.total': '总卡片数',
  'pages.adminUserCards.stats.active': '正常卡片',
  'pages.adminUserCards.stats.frozen': '冻结卡片',
  'pages.adminUserCards.stats.cancelled': '已注销',
  'pages.adminUserCards.column.userId': '用户ID',
  'pages.adminUserCards.column.cardNumber': '卡号',
  'pages.adminUserCards.column.holderName': '持卡人',
  'pages.adminUserCards.column.cardOrg': '卡组织',
  'pages.adminUserCards.column.balance': '余额',
  'pages.adminUserCards.column.status': '状态',
  'pages.adminUserCards.column.createdAt': '创建时间',
  'pages.adminUserCards.column.action': '操作',
  'pages.adminUserCards.status.active': '正常',
  'pages.adminUserCards.status.frozen': '冻结',
  'pages.adminUserCards.status.cancelled': '已注销',
  'pages.adminUserCards.action.detail': '详情',
  'pages.adminUserCards.action.transactions': '记录',
  'pages.adminUserCards.action.edit': '编辑',
  'pages.adminUserCards.action.refresh': '刷新',
  'pages.adminUserCards.detail.title': '卡片详情',
  'pages.adminUserCards.detail.basicInfo': '基本信息',
  'pages.adminUserCards.detail.sensitiveInfo': '敏感信息',
  'pages.adminUserCards.detail.showSensitive': '显示',
  'pages.adminUserCards.detail.hideSensitive': '隐藏',
  'pages.adminUserCards.detail.fullCardNumber': '完整卡号',
  'pages.adminUserCards.detail.expireDate': '过期日期',
  'pages.adminUserCards.detail.clickToShow': '点击上方按钮显示敏感信息',
  'pages.adminUserCards.transactions.title': '交易记录',
  'pages.adminUserCards.transactions.total': '共 {total} 条记录',
  'pages.adminUserCards.transactions.column.transactionNo': '交易单号',
  'pages.adminUserCards.transactions.column.time': '创建时间',
  'pages.adminUserCards.transactions.column.completedAt': '完成时间',
  'pages.adminUserCards.transactions.column.type': '类型',
  'pages.adminUserCards.transactions.column.amount': '交易金额',
  'pages.adminUserCards.transactions.column.fee': '手续费',
  'pages.adminUserCards.transactions.column.actualAmount': '实际到账',
  'pages.adminUserCards.transactions.column.balance': '余额变化',
  'pages.adminUserCards.transactions.column.status': '状态',
  'pages.adminUserCards.transactions.column.merchant': '商户',
  'pages.adminUserCards.transactions.column.upstreamFee': '上游费用',
  'pages.adminUserCards.transactions.column.upstreamOrderNo': '上游单号',
  'pages.adminUserCards.transactions.column.platformFee': '平台收益',
  'pages.adminUserCards.transactions.upstreamAmount': '金额',
  'pages.adminUserCards.transactions.upstreamFee': '费用',
  'pages.adminUserCards.transactions.platformFee': '费用',
  'pages.adminUserCards.transactions.platformProfit': '利润',
  'pages.adminUserCards.transactions.type.recharge': '充值',
  'pages.adminUserCards.transactions.type.withdraw': '提现',
  'pages.adminUserCards.transactions.type.payment': '消费',
  'pages.adminUserCards.transactions.type.refund': '退款',
  'pages.adminUserCards.transactions.status.success': '成功',
  'pages.adminUserCards.transactions.status.pending': '处理中',
  'pages.adminUserCards.transactions.status.failed': '失败',
  'pages.adminUserCards.edit.title': '编辑卡片',
  'pages.adminUserCards.edit.sensitiveFields': '敏感信息（可选）',
  'pages.adminUserCards.edit.leaveEmptyNoChange': '留空表示不修改',

  // 卡片申请管理
  'pages.cardApplication.title': '卡片申请管理',
  'pages.cardApplication.loadFailed': '加载失败',
  'pages.cardApplication.loadDetailFailed': '加载详情失败',
  'pages.cardApplication.updateSuccess': '更新成功',
  'pages.cardApplication.updateFailed': '更新失败',
  'pages.cardApplication.column.applicationNo': '申请编号',
  'pages.cardApplication.column.userId': '用户ID',
  'pages.cardApplication.column.cardProduct': '卡产品',
  'pages.cardApplication.column.issueFee': '购买费用',
  'pages.cardApplication.column.kycLevel': 'KYC等级',
  'pages.cardApplication.kycLevel.notSubmitted': '未提交',
  'pages.cardApplication.column.status': '状态',
  'pages.cardApplication.column.createdAt': '申请时间',
  'pages.cardApplication.column.action': '操作',
  'pages.cardApplication.status.pending': '待处理',
  'pages.cardApplication.status.kyc_failed': 'KYC失败',
  'pages.cardApplication.status.payment_failed': '支付失败',
  'pages.cardApplication.status.paid': '已支付',
  'pages.cardApplication.status.processing': '处理中',
  'pages.cardApplication.status.shipped': '已发货',
  'pages.cardApplication.status.pending_assign': '待分配审核',
  'pages.cardApplication.status.assigned': '待激活',
  'pages.cardApplication.status.pending_activation': '待激活审核',
  'pages.cardApplication.status.success': '成功',
  'pages.cardApplication.status.failed': '失败',
  'pages.cardApplication.status.cancelled': '已取消',
  'pages.cardApplication.stats.total': '申请总数',
  'pages.cardApplication.stats.pending': '待处理',
  'pages.cardApplication.stats.paid': '已支付',
  'pages.cardApplication.stats.processing': '处理中',
  'pages.cardApplication.stats.shipped': '已发货',
  'pages.cardApplication.stats.pending_assign': '待分配',
  'pages.cardApplication.stats.assigned': '待激活',
  'pages.cardApplication.stats.pending_activation': '待激活',
  'pages.cardApplication.stats.success': '成功',
  'pages.cardApplication.stats.failed': '失败',
  'pages.cardApplication.filter.all': '全部状态',
  'pages.cardApplication.filter.userId': '用户ID',
  'pages.cardApplication.filter.search': '搜索',
  'pages.cardApplication.action.view': '查看',
  'pages.cardApplication.action.update': '更新',
  'pages.cardApplication.action.refresh': '刷新',
  'pages.cardApplication.pagination.total': '共 {total} 条',
  'pages.cardApplication.detail.title': '申请详情',
  'pages.cardApplication.detail.applicationInfo': '申请信息',
  'pages.cardApplication.detail.cardInfo': '卡产品信息',
  'pages.cardApplication.detail.kycInfo': 'KYC信息',
  'pages.cardApplication.detail.paidAt': '支付时间',
  'pages.cardApplication.detail.statusMessage': '状态说明',
  'pages.cardApplication.detail.cardNumber': '卡号',
  'pages.cardApplication.detail.cardHolder': '持卡人',
  'pages.cardApplication.detail.cardName': '卡名称',
  'pages.cardApplication.detail.kycStatus': 'KYC状态',
  'pages.cardApplication.detail.cardNotFound': '卡产品信息未找到',
  'pages.cardApplication.detail.kycNotFound': 'KYC详细信息未找到',
  'pages.cardApplication.detail.kycNotSubmitted': '未提交KYC',
  'pages.cardApplication.update.title': '更新申请状态',
  'pages.cardApplication.update.confirm': '确认更新',
  'pages.cardApplication.update.statusRequired': '请选择状态',
  'pages.cardApplication.update.statusMessagePlaceholder':
    '可选，填写状态变更原因',
  // 上游操作
  'pages.cardApplication.detail.upstreamInfo': '上游操作记录',
  'pages.cardApplication.upstream.createHolder': '创建持卡人',
  'pages.cardApplication.upstream.createCard': '创建卡片',
  'pages.cardApplication.upstream.status.success': '成功',
  'pages.cardApplication.upstream.status.failed': '失败',
  'pages.cardApplication.upstream.status.pending': '处理中',
  'pages.cardApplication.upstream.requestTime': '请求时间',
  'pages.cardApplication.upstream.responseTime': '响应时间',
  'pages.cardApplication.upstream.upstreamId': '上游ID',
  'pages.cardApplication.upstream.callbackTime': '回调时间',
  'pages.cardApplication.upstream.requestData': '请求数据',
  'pages.cardApplication.upstream.responseData': '响应数据',
  'pages.cardApplication.upstream.callbackData': '回调数据',
  'pages.cardApplication.upstream.noData': '暂无上游操作记录',
  'pages.cardApplication.action.applyUpstream': '向上游申请卡片',
  'pages.cardApplication.action.manage': '管理',
  'pages.cardApplication.applyUpstream.confirmTitle': '确认向上游申请',
  'pages.cardApplication.applyUpstream.confirmContent':
    '确定要向上游申请卡片吗？申请编号: {applicationNo}',
  'pages.cardApplication.applyUpstream.confirm': '确认申请',
  'pages.cardApplication.applyUpstream.success': '申请已提交',
  'pages.cardApplication.applyUpstream.failed': '申请失败',
  'pages.cardApplication.manage.title': '申请管理',
  'pages.cardApplication.manage.finalStatusAlert':
    '该申请已处于终态，无法再修改',
  'pages.cardApplication.manage.operations': '操作',
  'pages.cardApplication.manage.applyUpstreamHint':
    '点击后将向上游服务商发起开卡申请',
  'pages.cardApplication.manage.updateStatus': '更新状态',
  'pages.cardApplication.manage.refundOption': '退还开卡费 ({fee} {currency})',
  'pages.cardApplication.action.refund': '退款',
  'pages.cardApplication.refund.confirmTitle': '确认退款',
  'pages.cardApplication.refund.confirmContent':
    '确定要退款 {fee} {currency} 给用户吗？申请编号: {applicationNo}',
  'pages.cardApplication.refund.confirm': '确认退款',
  'pages.cardApplication.refund.hint':
    '将取消申请并退还开卡费 {fee} {currency}',
  'pages.cardApplication.refund.statusMessage': '管理员手动退款取消',
  'pages.cardApplication.refund.success': '退款成功',
  'pages.cardApplication.refund.successWithAmount':
    '退款成功，已退还 {amount} {currency}',
  'pages.cardApplication.refund.failed': '退款失败',
  // 发货相关
  'pages.cardApplication.action.ship': '发货',
  'pages.cardApplication.manage.shipHint': '输入快递公司和物流单号后发货',
  'pages.cardApplication.ship.confirmTitle': '确认发货',
  'pages.cardApplication.ship.confirmContent': '请填写发货信息：',
  'pages.cardApplication.ship.confirm': '确认发货',
  'pages.cardApplication.ship.shippingCompanyLabel': '快递公司：',
  'pages.cardApplication.ship.shippingCompanyPlaceholder':
    '如：SF Express, DHL, FedEx',
  'pages.cardApplication.ship.shippingCompanyRequired': '请输入快递公司',
  'pages.cardApplication.ship.trackingNumberLabel': '快递单号：',
  'pages.cardApplication.ship.trackingNumberPlaceholder': '快递追踪号码',
  'pages.cardApplication.ship.trackingNumberRequired': '请输入快递单号',
  'pages.cardApplication.ship.success': '发货成功',
  'pages.cardApplication.ship.failed': '发货失败',
  // 收货地址相关
  'pages.cardApplication.detail.shippingAddress': '收货地址',
  'pages.cardApplication.detail.recipientName': '收件人',
  'pages.cardApplication.detail.recipientPhone': '手机号',
  'pages.cardApplication.detail.country': '国家',
  'pages.cardApplication.detail.province': '省/州',
  'pages.cardApplication.detail.city': '城市',
  'pages.cardApplication.detail.address': '详细地址',
  'pages.cardApplication.detail.postalCode': '邮编',
  'pages.cardApplication.detail.shippingCompany': '快递公司',
  'pages.cardApplication.detail.trackingNumber': '快递单号',
  'pages.cardApplication.detail.shippedAt': '发货时间',
  // 分配/激活信息相关
  'pages.cardApplication.detail.assignActivateInfo': '分配/激活信息',
  'pages.cardApplication.detail.cardNo': '用户提交卡号',
  'pages.cardApplication.detail.upstreamCardId': '上游卡ID',
  'pages.cardApplication.detail.activateCode': '激活码',
  'pages.cardApplication.detail.pin': 'PIN码',
  // 审批分配相关
  'pages.cardApplication.action.approveAssign': '审批分配',
  'pages.cardApplication.approveAssign.hint': '审批后系统将调用上游分配卡片',
  'pages.cardApplication.approveAssign.confirmTitle': '确认审批分配',
  'pages.cardApplication.approveAssign.confirmContent':
    '确认后系统将自动调用上游 AssignCard API 进行卡片分配',
  'pages.cardApplication.approveAssign.confirm': '确认审批',
  'pages.cardApplication.approveAssign.success': '审批成功，已提交分配请求',
  'pages.cardApplication.approveAssign.failed': '审批失败',
  // 审批激活相关
  'pages.cardApplication.action.approveActivation': '审批激活',
  'pages.cardApplication.approveActivation.hint':
    '审批后系统将调用上游激活卡片',
  'pages.cardApplication.approveActivation.confirmTitle': '确认审批激活',
  'pages.cardApplication.approveActivation.confirmContent':
    '确认后系统将自动调用上游 ActivateCard API 进行卡片激活',
  'pages.cardApplication.approveActivation.confirm': '确认审批',
  'pages.cardApplication.approveActivation.success': '审批成功，已提交激活请求',
  'pages.cardApplication.approveActivation.failed': '审批失败',

  // 重试分配（实体卡 failed -> assigned）
  'pages.cardApplication.action.retryAssign': '重试分配',
  'pages.cardApplication.retryAssign.hint':
    '重新调用上游 AssignCard API 进行分配',
  'pages.cardApplication.retryAssign.confirmTitle': '确认重试分配',
  'pages.cardApplication.retryAssign.confirmContent':
    '确认后系统将重新调用上游 AssignCard API 进行卡片分配',
  'pages.cardApplication.retryAssign.confirm': '确认重试',
  'pages.cardApplication.retryAssign.success': '重试分配已提交',
  'pages.cardApplication.retryAssign.failed': '重试分配失败',

  // 重试激活（实体卡 failed -> success）
  'pages.cardApplication.action.retryActivate': '重试激活',
  'pages.cardApplication.retryActivate.hint':
    '重新调用上游 ActivateCard API 进行激活',
  'pages.cardApplication.retryActivate.confirmTitle': '确认重试激活',
  'pages.cardApplication.retryActivate.confirmContent':
    '确认后系统将重新调用上游 ActivateCard API 进行卡片激活',
  'pages.cardApplication.retryActivate.confirm': '确认重试',
  'pages.cardApplication.retryActivate.success': '重试激活已提交',
  'pages.cardApplication.retryActivate.failed': '重试激活失败',

  // 角色管理页面
  'pages.roleManage.title': '角色权限管理',
  'pages.roleManage.roleList': '角色列表',
  'pages.roleManage.role.admin': '管理员',
  'pages.roleManage.role.admin.desc': '拥有系统所有权限',
  'pages.roleManage.role.agent': '代理',
  'pages.roleManage.role.agent.desc': '代理商角色，拥有部分管理权限',
  'pages.roleManage.role.referral': '推荐人',
  'pages.roleManage.role.referral.desc': '推荐人角色，可查看推荐数据',
  'pages.roleManage.role.user': '普通用户',
  'pages.roleManage.role.user.desc': '普通用户，基础权限',
  'pages.roleManage.systemRole': '系统',
  'pages.roleManage.systemRoleTag': '系统角色',
  'pages.roleManage.customRoleTag': '自定义',
  'pages.roleManage.configPermission': '配置权限',
  'pages.roleManage.selectRole': '请选择角色',
  'pages.roleManage.selectRoleToConfig': '请选择一个角色进行配置',
  'pages.roleManage.roleIdentifier': '角色标识',
  'pages.roleManage.selectedPermissions': '已选权限',
  'pages.roleManage.items': '项',
  'pages.roleManage.permissionConfig': '权限配置',
  'pages.roleManage.permissionUpdated': '权限已更新',
  'pages.roleManage.roleUpdated': '角色已更新',
  'pages.roleManage.resetSuccess': '已重置为默认权限',
  'pages.roleManage.action.resetDefault': '重置默认',
  'pages.roleManage.action.edit': '编辑',
  'pages.roleManage.action.save': '保存',
  'pages.roleManage.confirm.reset': '确定要重置为默认权限吗？',
  'pages.roleManage.confirm.ok': '确定',
  'pages.roleManage.confirm.cancel': '取消',
  'pages.roleManage.modal.editRole': '编辑角色',
  'pages.roleManage.modal.addRole': '新增角色',
  'pages.roleManage.form.roleName': '角色名称',
  'pages.roleManage.form.roleName.required': '请输入角色名称',
  'pages.roleManage.form.roleName.placeholder': '请输入角色名称',
  'pages.roleManage.form.roleDesc': '角色描述',
  'pages.roleManage.form.roleDesc.placeholder': '请输入角色描述',

  // KYC管理页面
  'pages.kycManage.title': 'KYC管理',
  'pages.kycManage.stats.total': 'KYC总数',
  'pages.kycManage.stats.pendingLevel1': 'Level 1 待审核',
  'pages.kycManage.stats.pendingLevel2': 'Level 2 待审核',
  'pages.kycManage.stats.pendingLevel3': 'Level 3 待审核',
  'pages.kycManage.stats.approvedToday': '今日通过',
  'pages.kycManage.stats.rejectedToday': '今日拒绝',
  'pages.kycManage.column.userId': '用户ID',
  'pages.kycManage.column.name': '姓名',
  'pages.kycManage.column.idNumber': '证件号',
  'pages.kycManage.column.idType': '证件类型',
  'pages.kycManage.column.currentLevel': '当前等级',
  'pages.kycManage.column.status': '状态',
  'pages.kycManage.column.submittedAt': '提交时间',
  'pages.kycManage.column.action': '操作',
  'pages.kycManage.status.pending': '待审核',
  'pages.kycManage.status.approved': '已通过',
  'pages.kycManage.status.rejected': '已拒绝',
  'pages.kycManage.idType.id_card': '身份证',
  'pages.kycManage.idType.passport': '护照',
  'pages.kycManage.idType.driver_license': '驾照',
  'pages.kycManage.level.0': '未认证',
  'pages.kycManage.level.1': 'Level 1',
  'pages.kycManage.level.2': 'Level 2',
  'pages.kycManage.level.3': 'Level 3',
  'pages.kycManage.action.view': '查看',
  'pages.kycManage.action.review': '审核',
  'pages.kycManage.filter.all': '全部',
  'pages.kycManage.filter.pending': '待审核',
  'pages.kycManage.filter.approved': '已通过',
  'pages.kycManage.filter.rejected': '已拒绝',
  'pages.kycManage.filter.level': '筛选等级',
  'pages.kycManage.search.placeholder': '搜索姓名或证件号',
  'pages.kycManage.detail.title': 'KYC详情',
  'pages.kycManage.detail.basicInfo': '基本信息',
  'pages.kycManage.detail.level1': 'Level 1 - 身份认证',
  'pages.kycManage.detail.level2': 'Level 2 - 高级认证',
  'pages.kycManage.detail.level3': 'Level 3 - 专业认证',
  'pages.kycManage.detail.firstName': '名',
  'pages.kycManage.detail.lastName': '姓',
  'pages.kycManage.detail.fullName': '姓名',
  'pages.kycManage.detail.gender': '性别',
  'pages.kycManage.detail.gender.male': '男',
  'pages.kycManage.detail.gender.female': '女',
  'pages.kycManage.detail.birthday': '出生日期',
  'pages.kycManage.detail.email': '邮箱',
  'pages.kycManage.detail.phone': '手机号',
  'pages.kycManage.detail.country': '国家/地区',
  'pages.kycManage.detail.address': '地址',
  'pages.kycManage.detail.postCode': '邮编',
  'pages.kycManage.detail.idPhotos': '证件照片',
  'pages.kycManage.detail.idFront': '正面',
  'pages.kycManage.detail.idBack': '背面',
  'pages.kycManage.detail.facePhoto': '人脸照片',
  'pages.kycManage.detail.addressProof': '地址证明',
  'pages.kycManage.detail.incomeProof': '收入证明',
  'pages.kycManage.detail.resume': '简历',
  'pages.kycManage.detail.taxProof': '税务证明',
  'pages.kycManage.detail.otherDocs': '其他文件',
  'pages.kycManage.detail.notSubmitted': '未提交',
  'pages.kycManage.detail.reviewedBy': '审核人',
  'pages.kycManage.detail.reviewedAt': '审核时间',
  'pages.kycManage.detail.rejectReason': '拒绝原因',
  'pages.kycManage.review.title': '审核KYC',
  'pages.kycManage.review.approve': '通过',
  'pages.kycManage.review.reject': '拒绝',
  'pages.kycManage.review.rejectReason': '拒绝原因',
  'pages.kycManage.review.rejectReason.required': '请输入拒绝原因',
  'pages.kycManage.review.rejectReason.placeholder':
    '请输入拒绝原因，用户将看到此内容',
  'pages.kycManage.review.success': '审核成功',
  'pages.kycManage.review.failed': '审核失败',
  'pages.kycManage.review.confirm.approve': '确定通过该等级认证？',
  'pages.kycManage.review.confirm.reject': '确定拒绝该等级认证？',
  'pages.kycManage.loadFailed': '加载失败',
  // 自动审核
  'pages.kycManage.autoReview.label': '自动审核 (L1)',
  'pages.kycManage.autoReview.tooltip':
    '开启后，Level 1 KYC 格式校验通过将自动审批',
  'pages.kycManage.autoReview.on': '开',
  'pages.kycManage.autoReview.off': '关',
  'pages.kycManage.autoReview.enabled': '自动审核已开启',
  'pages.kycManage.autoReview.disabled': '自动审核已关闭',
  'pages.kycManage.autoReview.failed': '更新自动审核状态失败',
  // 校验结果
  'pages.kycManage.detail.validationResult': '校验结果',
  'pages.kycManage.detail.validationPassed': '格式校验全部通过',
  'pages.kycManage.detail.validationFailed': '格式校验未通过',
  'pages.kycManage.detail.autoApproved': '已由系统自动审批',
  'pages.kycManage.detail.autoApprovedTag': '自动审批',
  // 拒绝代码
  'pages.kycManage.review.rejectCode': '拒绝原因',
  'pages.kycManage.review.rejectCode.placeholder': '请选择拒绝原因',
  'pages.kycManage.review.rejectCode.required': '请选择拒绝原因',
  'pages.kycManage.review.pendingLevel': '待审核等级',
  'pages.kycManage.rejectCode.INVALID_NAME_FORMAT': '姓名必须为英文',
  'pages.kycManage.rejectCode.INVALID_COUNTRY_CODE': '国家代码无效',
  'pages.kycManage.rejectCode.INVALID_PHONE_FORMAT': '手机号格式无效',
  'pages.kycManage.rejectCode.INVALID_PHONE_LENGTH': '手机号长度无效',
  'pages.kycManage.rejectCode.INVALID_EMAIL': '邮箱格式无效',
  'pages.kycManage.rejectCode.INVALID_DATE_FORMAT': '日期格式无效',
  'pages.kycManage.rejectCode.UNDERAGE': '未满18岁',
  'pages.kycManage.rejectCode.INVALID_AGE': '年龄无效',
  'pages.kycManage.rejectCode.DUPLICATE_ID_NUMBER': '证件号已被使用',
  'pages.kycManage.rejectCode.DUPLICATE_EMAIL': '邮箱已被使用',
  'pages.kycManage.rejectCode.DUPLICATE_PHONE': '手机号已被使用',
  'pages.kycManage.rejectCode.DUPLICATE_NAME': '姓名已被使用',
  'pages.kycManage.rejectCode.BLURRY_DOCUMENT': '证件照片模糊',
  'pages.kycManage.rejectCode.EXPIRED_DOCUMENT': '证件已过期',
  'pages.kycManage.rejectCode.INVALID_DOCUMENT': '证件无效',
  'pages.kycManage.rejectCode.FACE_MISMATCH': '人脸与证件不符',
  'pages.kycManage.rejectCode.OTHER': '其他原因',

  // 用户KYC信息
  'pages.userManage.kyc.title': 'KYC认证',
  'pages.userManage.kyc.empty': '暂无KYC记录',
  'pages.userManage.kyc.loadFailed': '加载KYC记录失败',
  'pages.userManage.kyc.currentLevel': '当前等级',
  'pages.userManage.kyc.viewDetail': '查看详情',
  'pages.userManage.kyc.count': '共 {count} 个KYC身份',
  'pages.userManage.kyc.identity': '身份',
  'pages.userManage.kyc.updatedAt': '更新时间',

  // 卡片管理
  'pages.cardManage.title': '卡片管理',
  'pages.cardManage.description': '管理平台卡产品',
  'pages.cardManage.column.id': 'ID',
  'pages.cardManage.column.cardId': '卡ID',
  'pages.cardManage.column.displayName': '产品名称',
  'pages.cardManage.column.displayNameEn': '名称(英)',
  'pages.cardManage.column.displayNameZh': '名称(中)',
  'pages.cardManage.column.description': '描述',
  'pages.cardManage.column.descriptionEn': '描述(英)',
  'pages.cardManage.column.descriptionZh': '描述(中)',
  'pages.cardManage.column.provider': '供应商',
  'pages.cardManage.column.currency': '币种',
  'pages.cardManage.column.cardBin': '卡BIN',
  'pages.cardManage.column.cardNetwork': '卡网络',
  'pages.cardManage.column.cardType': '卡类型',
  'pages.cardManage.column.supportedPayments': '支持平台',
  'pages.cardManage.column.issueRegion': '发行地区',
  'pages.cardManage.column.isRecommended': '推荐',
  'pages.cardManage.column.autoIssue': '发卡模式',
  'pages.cardManage.autoIssue.auto': '自动发卡',
  'pages.cardManage.autoIssue.manual': '人工审核',
  'pages.cardManage.autoIssue.auto.desc':
    '用户支付后自动发起上游开卡，状态直接变为处理中',
  'pages.cardManage.autoIssue.manual.desc':
    '用户支付后状态为已支付，需要管理员审核后发卡',
  'pages.cardManage.column.issueFee': '购买费用',
  'pages.cardManage.column.annualFee': '年费',
  'pages.cardManage.column.rechargeFeeRate': '充值费率',
  'pages.cardManage.column.withdrawFeeRate': '提现费率',
  'pages.cardManage.column.transactionFeeRate': '交易费率',
  'pages.cardManage.column.minRecharge': '最小充值',
  'pages.cardManage.column.maxRecharge': '最大充值',
  'pages.cardManage.column.dailyLimit': '日限额',
  'pages.cardManage.column.monthlyLimit': '月限额',
  'pages.cardManage.column.yearlyLimit': '年限额',
  'pages.cardManage.column.maxOpenCardCount': '最大开卡数',
  'pages.cardManage.column.validityYears': '有效期(年)',
  'pages.cardManage.column.isActive': '状态',
  'pages.cardManage.column.sortOrder': '排序',
  'pages.cardManage.column.createdAt': '创建时间',
  'pages.cardManage.column.updatedAt': '更新时间',
  'pages.cardManage.column.action': '操作',
  'pages.cardManage.action.edit': '编辑',
  'pages.cardManage.status.active': '上架',
  'pages.cardManage.status.inactive': '下架',
  'pages.cardManage.loadFailed': '加载失败',
  'pages.cardManage.tab.products': '卡片产品',
  'pages.cardManage.tab.upstream': '上游管理',
  // 上游管理
  'pages.cardManage.upstream.title': '上游产品',
  'pages.cardManage.upstream.sync': '同步上游',
  'pages.cardManage.upstream.syncing': '同步中...',
  'pages.cardManage.upstream.syncSuccess': '同步成功，共同步 {count} 个产品',
  'pages.cardManage.upstream.syncFailed': '同步失败',
  'pages.cardManage.upstream.manualInput': '手动录入产品',
  // 手动录入
  'pages.cardManage.manual.title': '手动录入产品',
  'pages.cardManage.manual.submit': '确认录入',
  'pages.cardManage.manual.success': '产品录入成功',
  'pages.cardManage.manual.failed': '产品录入失败',
  'pages.cardManage.manual.basicInfo': '基础信息',
  'pages.cardManage.manual.providerCode': '供应商',
  'pages.cardManage.manual.providerCode.placeholder': '如: ispay, stripe',
  'pages.cardManage.manual.upstreamProductId': '上游产品ID',
  'pages.cardManage.manual.upstreamProductId.placeholder': '输入唯一标识符',
  'pages.cardManage.upstream.column.id': 'ID',
  'pages.cardManage.upstream.column.productId': '上游产品ID',
  'pages.cardManage.upstream.column.productName': '产品名称',
  'pages.cardManage.upstream.column.provider': '供应商',
  'pages.cardManage.upstream.column.currency': '币种',
  'pages.cardManage.upstream.column.cardType': '卡类型',
  'pages.cardManage.upstream.column.cardBin': '卡BIN',
  'pages.cardManage.upstream.column.maxQuota': '最大配额',
  'pages.cardManage.upstream.column.status': '状态',
  'pages.cardManage.upstream.column.syncedAt': '同步时间',
  'pages.cardManage.upstream.column.isImported': '已导入',
  'pages.cardManage.upstream.column.upstreamProductId': '上游产品ID',
  'pages.cardManage.upstream.column.cardScheme': '卡组织',
  'pages.cardManage.upstream.column.upstreamTime': '上游时间',
  'pages.cardManage.upstream.column.createTime': '创建',
  'pages.cardManage.upstream.column.updateTime': '更新',
  'pages.cardManage.upstream.status.enabled': '启用',
  'pages.cardManage.upstream.status.disabled': '禁用',
  'pages.cardManage.upstream.imported.yes': '是',
  'pages.cardManage.upstream.imported.no': '否',
  'pages.cardManage.upstream.cardType.virtual': '虚拟卡',
  'pages.cardManage.upstream.cardType.physical': '实体卡',
  'pages.cardManage.upstream.action.import': '上架',
  'pages.cardManage.upstream.action.imported': '已上架',
  // 导入/编辑产品弹窗
  'pages.cardManage.import.title': '上架产品',
  'pages.cardManage.edit.title': '编辑产品',
  'pages.cardManage.import.subtitle': '将上游产品导入到平台',
  'pages.cardManage.import.upstreamInfo': '上游产品信息',
  'pages.cardManage.import.productInfo': '产品信息',
  'pages.cardManage.import.platformSettings': '平台设置',
  'pages.cardManage.import.feeSettings': '费率设置',
  'pages.cardManage.import.limitSettings': '限额设置',
  'pages.cardManage.import.otherSettings': '其他设置',
  'pages.cardManage.import.displayNameEn': '名称 (英文)',
  'pages.cardManage.import.displayNameEn.required': '请输入英文名称',
  'pages.cardManage.import.displayNameEn.placeholder': '请输入英文产品名称',
  'pages.cardManage.import.displayNameZh': '名称 (中文)',
  'pages.cardManage.import.displayNameZh.placeholder': '请输入中文产品名称',
  'pages.cardManage.import.descriptionEn': '描述 (英文)',
  'pages.cardManage.import.descriptionEn.placeholder': '请输入英文产品描述',
  'pages.cardManage.import.descriptionZh': '描述 (中文)',
  'pages.cardManage.import.descriptionZh.placeholder': '请输入中文产品描述',
  'pages.cardManage.import.cardImageUrl': '卡面图片',
  'pages.cardManage.import.cardImageUrl.placeholder': '请输入卡面图片URL',
  'pages.cardManage.import.cardBin': '卡BIN',
  'pages.cardManage.import.cardBin.placeholder': '如 40963608',
  'pages.cardManage.import.cardNetwork': '卡网络',
  'pages.cardManage.import.cardNetwork.placeholder': '请选择卡网络',
  'pages.cardManage.import.cardNetwork.visa': 'VISA',
  'pages.cardManage.import.cardNetwork.master': 'MasterCard',
  'pages.cardManage.import.cardNetwork.unionpay': '银联',
  'pages.cardManage.import.cardType': '卡类型',
  'pages.cardManage.import.cardType.placeholder': '请选择卡类型',
  'pages.cardManage.import.cardType.virtual': '虚拟卡',
  'pages.cardManage.import.cardType.physical': '实体卡',
  'pages.cardManage.import.cardCurrency': '卡币种',
  'pages.cardManage.import.cardCurrency.placeholder': '请选择币种',
  'pages.cardManage.import.cardCurrency.USD': '美元 (USD)',
  'pages.cardManage.import.cardCurrency.EUR': '欧元 (EUR)',
  'pages.cardManage.import.cardCurrency.GBP': '英镑 (GBP)',
  'pages.cardManage.import.cardCurrency.CNY': '人民币 (CNY)',
  'pages.cardManage.import.supportedPayments': '支持平台',
  'pages.cardManage.import.supportedPayments.placeholder': '请选择支持的平台',
  'pages.cardManage.import.supportedPayments.alipay': '支付宝',
  'pages.cardManage.import.supportedPayments.wechatpay': '微信支付',
  'pages.cardManage.import.supportedPayments.applepay': 'Apple Pay',
  'pages.cardManage.import.supportedPayments.googlepay': 'Google Pay',
  'pages.cardManage.import.supportedPayments.paypal': 'PayPal',
  'pages.cardManage.import.issueRegion': '发行地区',
  'pages.cardManage.import.issueRegion.placeholder': '如 Hong Kong, USA',
  // 费用分组标题
  'pages.cardManage.import.basicFeeSettings': '基础费用设置',
  'pages.cardManage.import.transactionFeeSettings': '交易相关费用',
  'pages.cardManage.import.rechargeFeeSettings': '充提费用',
  'pages.cardManage.import.atmFeeSettings': 'ATM相关费用',
  'pages.cardManage.import.otherFeeSettings': '其他费用',
  // 费用字段
  'pages.cardManage.import.issueFee': '购买费用',
  'pages.cardManage.import.annualFee': '年费',
  'pages.cardManage.import.monthlyFee': '月服务费',
  'pages.cardManage.import.feeShow': '显示给用户',
  'pages.cardManage.import.transactionFeeRate': '交易费率',
  'pages.cardManage.import.transactionFeeFixed': '交易固定费',
  'pages.cardManage.import.authFee': '授权手续费',
  'pages.cardManage.import.authFailFee': '授权失败费',
  'pages.cardManage.import.refundFee': '退款手续费',
  'pages.cardManage.import.chargebackFee': 'Chargeback费',
  'pages.cardManage.import.rechargeFeeRate': '充值费率',
  'pages.cardManage.import.rechargeFeeRate.placeholder': '如 0.02 表示 2%',
  'pages.cardManage.import.rechargeFeeRate.tooltip':
    '平台向用户收取的充值手续费率',
  'pages.cardManage.import.withdrawFeeRate': '提现费率',
  'pages.cardManage.import.withdrawFeeRate.tooltip':
    '平台向用户收取的提现手续费率',
  'pages.cardManage.import.upstreamRechargeFeeRate': '上游充值费率',
  'pages.cardManage.import.upstreamRechargeFeeRate.tooltip':
    '上游 (ISPay) 向平台收取的充值费率',
  'pages.cardManage.import.upstreamWithdrawFeeRate': '上游提现费率',
  'pages.cardManage.import.upstreamWithdrawFeeRate.tooltip':
    '上游 (ISPay) 向平台收取的提现费率',
  'pages.cardManage.import.atmWithdrawFee': 'ATM提现费',
  'pages.cardManage.import.atmBalanceFee': 'ATM查询费',
  'pages.cardManage.import.tdsFee': '3DS费用',
  'pages.cardManage.import.smallAmountFee': '小额交易费',
  'pages.cardManage.import.specialRegionFee': '特殊地区费',
  'pages.cardManage.import.specialRegionFeeMin': '特殊地区费(最低)',
  'pages.cardManage.import.crossBorderFeeRate': '跨境费率',
  'pages.cardManage.import.crossBorderFeeMin': '跨境费(最低)',
  'pages.cardManage.import.minRecharge': '最小充值 (USD)',
  'pages.cardManage.import.maxRecharge': '最大充值 (USD)',
  'pages.cardManage.import.dailyLimit': '日限额 (USD)',
  'pages.cardManage.import.monthlyLimit': '月限额 (USD)',
  'pages.cardManage.import.yearlyLimit': '年限额 (USD)',
  'pages.cardManage.import.maxOpenCardCount': '最大开卡数',
  'pages.cardManage.import.maxOpenCardCount.hint': '每个用户最多可开卡数量',
  'pages.cardManage.import.validityYears': '有效期 (年)',
  'pages.cardManage.import.validityYears.hint': '卡片有效期年限',
  'pages.cardManage.import.isActive': '立即上架',
  'pages.cardManage.import.isRecommended': '推荐产品',
  'pages.cardManage.import.autoIssue': '自动发卡',
  'pages.cardManage.import.autoIssue.tooltip':
    '开启后，用户支付成功将自动发起上游开卡；关闭则需管理员手动审核',
  'pages.cardManage.import.sortOrder': '排序权重',
  'pages.cardManage.import.sortOrder.hint': '数字越小越靠前',
  'pages.cardManage.import.success': '产品上架成功',
  'pages.cardManage.import.failed': '产品上架失败',
  'pages.cardManage.edit.success': '产品更新成功',
  'pages.cardManage.edit.failed': '产品更新失败',
  'pages.cardManage.import.submit': '确认上架',
  'pages.cardManage.edit.submit': '保存修改',
  'pages.cardManage.import.cancel': '取消',

  // 账户设置页面
  'pages.account.settings.menu.base': '基本设置',
  'pages.account.settings.menu.security': '安全设置',
  'pages.account.settings.menu.apikeys': 'API Key',

  // 基本设置
  'pages.account.settings.userId': '用户ID',
  'pages.account.settings.email': '邮箱',
  'pages.account.settings.email.hint': '邮箱请在安全设置中修改',
  'pages.account.settings.nickname': '昵称',
  'pages.account.settings.nickname.required': '请输入您的昵称!',
  'pages.account.settings.nickname.maxLength': '昵称最长50个字符',
  'pages.account.settings.nickname.placeholder': '请输入昵称',
  'pages.account.settings.submit': '更新基本信息',
  'pages.account.settings.updateSuccess': '更新基本信息成功',
  'pages.account.settings.updateFailed': '更新基本信息失败',

  // 头像上传
  'pages.account.settings.avatar.title': '头像',
  'pages.account.settings.avatar.upload': '上传头像',
  'pages.account.settings.avatar.typeError': '只能上传图片文件!',
  'pages.account.settings.avatar.sizeError': '图片大小不能超过 10MB!',
  'pages.account.settings.avatar.uploadSuccess': '头像上传成功',
  'pages.account.settings.avatar.uploadFailed': '头像上传失败',

  // 安全设置
  'pages.account.settings.security.password': '账户密码',
  'pages.account.settings.security.password.desc':
    '定期更换密码可以提高账户安全性',
  'pages.account.settings.security.modify': '修改',
  'pages.account.settings.security.email': '绑定邮箱',
  'pages.account.settings.security.email.bound': '已绑定邮箱',
  'pages.account.settings.security.email.notBound': '未绑定邮箱',
  'pages.account.settings.security.change': '更换',
  'pages.account.settings.security.bind': '绑定',

  // 修改密码
  'pages.account.settings.password.title': '修改密码',
  'pages.account.settings.password.old': '当前密码',
  'pages.account.settings.password.old.required': '请输入当前密码',
  'pages.account.settings.password.old.placeholder': '请输入当前密码',
  'pages.account.settings.password.new': '新密码',
  'pages.account.settings.password.new.required': '请输入新密码',
  'pages.account.settings.password.new.minLength': '密码至少6个字符',
  'pages.account.settings.password.new.placeholder': '请输入新密码',
  'pages.account.settings.password.confirm': '确认新密码',
  'pages.account.settings.password.confirm.required': '请确认新密码',
  'pages.account.settings.password.confirm.placeholder': '请再次输入新密码',
  'pages.account.settings.password.mismatch': '两次输入的密码不一致',
  'pages.account.settings.password.submit': '确认修改',
  'pages.account.settings.password.success': '密码修改成功',
  'pages.account.settings.password.failed': '密码修改失败',

  // 修改邮箱
  'pages.account.settings.email.changeTitle': '更换邮箱',
  'pages.account.settings.email.bindTitle': '绑定邮箱',
  'pages.account.settings.email.step1': '验证当前邮箱',
  'pages.account.settings.email.step2': '绑定新邮箱',
  'pages.account.settings.email.currentEmail': '当前邮箱',
  'pages.account.settings.email.newEmail': '新邮箱',
  'pages.account.settings.email.newEmail.required': '请输入新邮箱',
  'pages.account.settings.email.newEmail.invalid': '邮箱格式不正确',
  'pages.account.settings.email.newEmail.placeholder': '请输入新邮箱地址',
  'pages.account.settings.email.code.required': '请输入验证码',
  'pages.account.settings.email.code.length': '验证码为6位数字',
  'pages.account.settings.email.code.placeholder': '6位验证码',
  'pages.account.settings.email.sendCode': '发送验证码',
  'pages.account.settings.email.codeSent': '验证码已发送',
  'pages.account.settings.email.sendFailed': '发送验证码失败',
  'pages.account.settings.email.verifyNext': '验证并下一步',
  'pages.account.settings.email.currentVerified': '当前邮箱验证成功',
  'pages.account.settings.email.currentVerifiedTip':
    '当前邮箱已验证，请在30分钟内完成新邮箱绑定',
  'pages.account.settings.email.verifyFailed': '验证失败',
  'pages.account.settings.email.inputNewEmail': '请先输入新邮箱',
  'pages.account.settings.email.confirmBind': '确认绑定',
  'pages.account.settings.email.bindSuccess': '邮箱绑定成功',
  'pages.account.settings.email.bindFailed': '邮箱绑定失败',

  // API Key 管理
  'pages.account.settings.apiKey.title': 'API Key 管理',
  'pages.account.settings.apiKey.create': '创建 API Key',
  'pages.account.settings.apiKey.empty': '暂无 API Key',
  'pages.account.settings.apiKey.loadFailed': '加载失败',
  'pages.account.settings.apiKey.createSuccess': '创建成功',
  'pages.account.settings.apiKey.createFailed': '创建失败',
  'pages.account.settings.apiKey.revokeSuccess': '撤销成功',
  'pages.account.settings.apiKey.revokeFailed': '撤销失败',
  'pages.account.settings.apiKey.revokeConfirm': '确定要撤销此 API Key 吗？',
  'pages.account.settings.apiKey.revoke': '撤销',
  'pages.account.settings.apiKey.copied': '已复制',
  'pages.account.settings.apiKey.copy': '复制',
  'pages.account.settings.apiKey.confirm': '确定',
  'pages.account.settings.apiKey.cancel': '取消',
  'pages.account.settings.apiKey.understood': '我已保存，关闭',
  'pages.account.settings.apiKey.secretWarning':
    '请立即保存以下信息，Secret 只显示一次！',
  'pages.account.settings.apiKey.column.name': '名称',
  'pages.account.settings.apiKey.column.permissions': '权限',
  'pages.account.settings.apiKey.column.status': '状态',
  'pages.account.settings.apiKey.column.lastUsed': '最后使用',
  'pages.account.settings.apiKey.column.action': '操作',
  'pages.account.settings.apiKey.status.active': '有效',
  'pages.account.settings.apiKey.status.revoked': '已撤销',
  'pages.account.settings.apiKey.permission.trade': '交易',
  'pages.account.settings.apiKey.permission.trade.desc': '创建和取消订单',
  'pages.account.settings.apiKey.permission.withdraw': '提现',
  'pages.account.settings.apiKey.permission.withdraw.desc':
    '发起提现请求（高风险）',
  'pages.account.settings.apiKey.permission.read': '只读',
  'pages.account.settings.apiKey.permission.read.desc':
    '查看账户信息、余额、订单',
  'pages.account.settings.apiKey.form.name': '名称',
  'pages.account.settings.apiKey.form.name.required': '请输入名称',
  'pages.account.settings.apiKey.form.name.maxLength': '名称最多50个字符',
  'pages.account.settings.apiKey.form.name.placeholder': '例如：交易机器人',
  'pages.account.settings.apiKey.form.permissions': '权限',
  'pages.account.settings.apiKey.form.permissions.required':
    '请选择至少一个权限',

  // 会话管理
  'pages.account.settings.menu.sessions': '会话管理',
  'pages.account.settings.sessions.title': '会话管理',
  'pages.account.settings.sessions.historyDeprojection':
    '查看您的登录历史记录，记录保留 90 天。',
  'pages.account.settings.sessions.tab.devices': '登录设备',
  'pages.account.settings.sessions.tab.history': '登录历史',
  'pages.account.settings.sessions.loadFailed': '加载失败',
  'pages.account.settings.sessions.empty': '暂无会话',
  'pages.account.settings.sessions.historyEmpty': '暂无登录记录',
  'pages.account.settings.sessions.total': '共 {total} 个设备',
  'pages.account.settings.sessions.historyTotal': '共 {total} 条记录',
  'pages.account.settings.sessions.currentDevice': '当前设备',
  'pages.account.settings.sessions.revokeOthers': '下线所有其他设备',
  'pages.account.settings.sessions.revokeOthersConfirmTitle':
    '下线所有其他设备',
  'pages.account.settings.sessions.revokeOthersConfirmContent':
    '确定要下线除当前设备外的所有其他设备吗？此操作不可撤销。',
  'pages.account.settings.sessions.revokeOthersSuccess':
    '已下线 {count} 个设备',
  'pages.account.settings.sessions.revokeOthersFailed': '下线失败',
  'pages.account.settings.sessions.revokeConfirm': '确定要下线此设备吗？',
  'pages.account.settings.sessions.revokeSuccess': '设备已下线',
  'pages.account.settings.sessions.revokeFailed': '下线失败',
  'pages.account.settings.sessions.revoke': '下线',
  'pages.account.settings.sessions.confirm': '确定',
  'pages.account.settings.sessions.cancel': '取消',
  'pages.account.settings.sessions.search': '查询',
  'pages.account.settings.sessions.filterStatus': '筛选状态',
  'pages.account.settings.sessions.column.device': '设备',
  'pages.account.settings.sessions.column.location': '位置',
  'pages.account.settings.sessions.column.loginMethod': '登录方式',
  'pages.account.settings.sessions.column.lastActive': '最后活跃',
  'pages.account.settings.sessions.column.action': '操作',
  'pages.account.settings.sessions.column.time': '时间',
  'pages.account.settings.sessions.column.status': '状态',
  'pages.account.settings.sessions.device.desktop': '桌面端',
  'pages.account.settings.sessions.device.mobile': '移动端',
  'pages.account.settings.sessions.device.tablet': '平板',
  'pages.account.settings.sessions.device.unknown': '未知',
  'pages.account.settings.sessions.loginMethod.password': '密码登录',
  'pages.account.settings.sessions.loginMethod.google': 'Google 登录',
  'pages.account.settings.sessions.loginMethod.apikey': 'API Key',
  'pages.account.settings.sessions.status.success': '成功',
  'pages.account.settings.sessions.status.failed': '失败',

  // 充提记录页面
  'pages.wallet.records.title': '充提记录',
  'pages.wallet.stats.depositPending': '充值待处理',
  'pages.wallet.stats.withdrawPending': '提现待处理',
  'pages.wallet.stats.failed': '失败任务',
  'pages.wallet.stats.unmatched': '未匹配地址',
  'pages.wallet.tab.all': '全部',
  'pages.wallet.tab.deposit': '充值',
  'pages.wallet.tab.withdraw': '提现',
  'pages.wallet.tab.failed': '失败',
  'pages.wallet.tab.unmatched': '未匹配',
  'pages.wallet.column.userId': '用户ID',
  'pages.wallet.column.type': '类型',
  'pages.wallet.column.symbol': '币种',
  'pages.wallet.column.amount': '金额',
  'pages.wallet.column.chain': '链',
  'pages.wallet.column.address': '地址',
  'pages.wallet.column.status': '状态',
  'pages.wallet.column.createdAt': '创建时间',
  'pages.wallet.column.error': '错误信息',
  'pages.wallet.type.deposit': '充值',
  'pages.wallet.type.withdraw': '提现',
  'pages.wallet.status.pending': '处理中',
  'pages.wallet.status.completed': '已完成',
  'pages.wallet.status.failed': '失败',
  'pages.wallet.error.fetchFailed': '获取数据失败',

  // 历史记录页面
  'pages.wallet.history.title': '历史记录',
  'pages.wallet.history.type.all': '全部',
  'pages.wallet.history.type.deposit': '链上充值',
  'pages.wallet.history.type.withdrawal': '链上提现',
  'pages.wallet.history.type.swap': '兑换',
  'pages.wallet.history.type.pay': '支付',
  'pages.wallet.history.type.refund': '退款',
  'pages.wallet.history.type.internal_transfer': '内部转账',
  'pages.wallet.history.type.internal_deposit': '余额调整',
  'pages.wallet.history.type.card_issue': '开卡',
  'pages.wallet.history.type.card_recharge': '卡充值',
  'pages.wallet.history.type.card_withdraw': '卡提现',
  'pages.wallet.history.type.referral_reward': '推荐奖励',
  'pages.wallet.history.type.deposit.short': '充值',
  'pages.wallet.history.type.withdrawal.short': '提现',
  'pages.wallet.history.type.swap.short': '兑换',
  'pages.wallet.history.type.pay.short': '支付',
  'pages.wallet.history.type.refund.short': '退款',
  'pages.wallet.history.type.internal_transfer.short': '转账',
  'pages.wallet.history.type.internal_deposit.short': '调账',
  'pages.wallet.history.type.card_issue.short': '开卡',
  'pages.wallet.history.type.card_recharge.short': '卡充值',
  'pages.wallet.history.type.card_withdraw.short': '卡提现',
  'pages.wallet.history.type.referral_reward.short': '推荐奖励',
  'pages.wallet.history.column.description': '描述',
  'pages.wallet.history.filter.userId': '用户ID',
  'pages.wallet.history.filter.type': '类型',
  'pages.wallet.history.filter.symbol': '币种 (如 USDT)',

  // 我的资产页面
  'pages.assets.balances.title': '我的资产',
  'pages.assets.addresses.title': '充值地址',
  'pages.assets.deposit.title': '充值',
  'pages.assets.deposit.subtitle': '选择币种和网络进行充值',
  'pages.assets.deposit.selectCurrency': '币种',
  'pages.assets.deposit.selectNetwork': '网络',
  'pages.assets.deposit.warning.desc':
    '请仅通过 {network} 网络发送 {symbol}，发送其他资产将导致资产丢失。',
  'pages.assets.deposit.noAddress': '未找到地址',
  'pages.assets.deposit.noAssets': '暂无可用资产',
  'pages.assets.history.title': '交易记录',
  'pages.assets.refresh': '刷新',
  'pages.assets.frozen': '冻结',
  'pages.assets.noBalances': '暂无资产',
  'pages.assets.noDigitalAssets': '暂无数字资产',
  'pages.assets.noFiatAssets': '暂无法币资产',
  'pages.assets.noAddresses': '暂无充值地址',
  'pages.assets.networks': '个网络',
  'pages.assets.copy': '复制',
  'pages.assets.copied': '已复制',
  'pages.assets.copyFailed': '复制失败',
  'pages.assets.tab.all': '全部',
  'pages.assets.tab.deposit': '充值',
  'pages.assets.tab.withdraw': '提现',
  'pages.assets.column.type': '类型',
  'pages.assets.column.symbol': '币种',
  'pages.assets.column.amount': '金额',
  'pages.assets.column.chain': '链',
  'pages.assets.column.address': '地址',
  'pages.assets.column.status': '状态',
  'pages.assets.column.createdAt': '时间',
  'pages.assets.type.deposit': '充值',
  'pages.assets.type.withdraw': '提现',
  'pages.assets.type.withdrawal': '提现',
  'pages.assets.type.swap': '兑换',
  'pages.assets.type.pay': '支付',
  'pages.assets.type.refund': '退款',
  'pages.assets.type.internal_transfer': '内部转账',
  'pages.assets.type.internal_deposit': '余额调整',
  'pages.assets.type.card_issue': '开卡',
  'pages.assets.type.card_recharge': '卡充值',
  'pages.assets.type.card_withdraw': '卡提现',
  'pages.assets.type.referral_reward': '推荐奖励',
  'pages.assets.status.pending': '处理中',
  'pages.assets.status.completed': '已完成',
  'pages.assets.status.failed': '失败',
  'pages.assets.error.loadBalances': '加载余额失败',
  'pages.assets.error.loadAddresses': '加载充值地址失败',
  'pages.assets.error.loadHistory': '加载交易记录失败',

  // 卡片申请页面
  'pages.myCards.refresh': '刷新',
  'pages.myCards.empty': '暂无可用卡产品',
  'pages.myCards.error.load': '加载卡产品失败',
  'pages.myCards.recommended': '推荐',
  'pages.myCards.type.virtual': '虚拟卡',
  'pages.myCards.type.physical': '实体卡',
  'pages.myCards.years': '年',
  // 列表列
  'pages.myCards.column.cardImage': '卡片',
  'pages.myCards.column.name': '产品名称',
  'pages.myCards.column.type': '类型',
  'pages.myCards.column.cardBin': '卡BIN',
  'pages.myCards.column.currency': '币种',
  'pages.myCards.column.issueFee': '购买费用',
  'pages.myCards.column.annualFee': '年费',
  'pages.myCards.column.transactionFee': '交易费',
  'pages.myCards.column.limits': '限额',
  'pages.myCards.column.action': '操作',
  'pages.myCards.action.detail': '详情',
  // 费用
  'pages.myCards.fee.issue': '购买费用',
  'pages.myCards.fee.annual': '年费',
  'pages.myCards.fee.monthly': '月服务费',
  'pages.myCards.fee.transaction': '交易手续费',
  'pages.myCards.fee.auth': '授权费',
  'pages.myCards.fee.refund': '退款费',
  'pages.myCards.fee.atm': 'ATM取现费',
  'pages.myCards.fee.crossBorder': '跨境手续费',
  'pages.myCards.fee.chargeback': '拒付费',
  'pages.myCards.fee.rechargeRate': '充值费率',
  'pages.myCards.fee.withdrawRate': '提现费率',
  // 详情弹窗
  'pages.myCards.detail.basic': '基本信息',
  'pages.myCards.detail.network': '卡网络',
  'pages.myCards.detail.cardBin': '卡BIN',
  'pages.myCards.detail.type': '卡类型',
  'pages.myCards.detail.currency': '币种',
  'pages.myCards.detail.region': '发行地区',
  'pages.myCards.detail.validity': '有效期',
  'pages.myCards.detail.maxCards': '最大开卡数',
  'pages.myCards.detail.payments': '支持支付方式',
  'pages.myCards.detail.limits': '额度限制',
  'pages.myCards.detail.minRecharge': '最小充值',
  'pages.myCards.detail.maxRecharge': '最大充值',
  'pages.myCards.detail.dailyLimit': '日消费限额',
  'pages.myCards.detail.monthlyLimit': '月消费限额',
  'pages.myCards.detail.yearlyLimit': '年消费限额',
  'pages.myCards.detail.fees': '费用明细',
  // Tab 标签
  'pages.myCards.tab.cardHolder': '持卡人管理',
  'pages.myCards.tab.applications': '我的申请',
  'pages.myCards.tab.cardProducts': '卡产品',
  'pages.myCards.action.apply': '申请',

  // 申请卡片弹窗
  'pages.cardApply.title': '申请开卡',
  'pages.cardApply.productInfo': '卡产品信息',
  'pages.cardApply.productName': '产品名称',
  'pages.cardApply.selectKyc': '选择持卡人',
  'pages.cardApply.selectKyc.required': '请选择持卡人',
  'pages.cardApply.selectKyc.placeholder': '请选择已认证的KYC身份',
  'pages.cardApply.selectKyc.placeholder.optional': '选择KYC身份（可选）',
  'pages.cardApply.selectKyc.optionalHint': '实体卡申请时KYC为可选项',
  'pages.cardApply.hint': '提交申请后，开卡费将从您的USD余额中扣除。',
  'pages.cardApply.hint.physical':
    '实体卡支付后将寄送到您填写的地址，请确保收货地址正确。',
  'pages.cardApply.submit': '提交申请',
  'pages.cardApply.success': '申请已提交！申请单号：{no}',
  'pages.cardApply.failed': '申请失败',
  'pages.cardApply.noKyc': '没有找到已认证的KYC身份',
  'pages.cardApply.noKyc.desc': '请先在"持卡人管理"中完成KYC认证。',
  // 实体卡收货地址
  'pages.cardApply.shippingAddress': '收货地址',
  'pages.cardApply.recipientName': '收件人姓名',
  'pages.cardApply.recipientName.placeholder': '请输入收件人姓名',
  'pages.cardApply.recipientName.required': '请输入收件人姓名',
  'pages.cardApply.recipientPhone': '手机号码',
  'pages.cardApply.recipientPhone.placeholder': '请输入手机号码',
  'pages.cardApply.recipientPhone.required': '请输入手机号码',
  'pages.cardApply.country': '国家',
  'pages.cardApply.country.placeholder': '请输入国家',
  'pages.cardApply.country.required': '请输入国家',
  'pages.cardApply.province': '省/州',
  'pages.cardApply.province.placeholder': '选填',
  'pages.cardApply.city': '城市',
  'pages.cardApply.city.placeholder': '选填',
  'pages.cardApply.address': '详细地址',
  'pages.cardApply.address.placeholder': '请输入详细地址',
  'pages.cardApply.address.required': '请输入详细地址',
  'pages.cardApply.postalCode': '邮政编码',
  'pages.cardApply.postalCode.placeholder': '选填',

  // 我的申请列表
  'pages.application.column.applicationNo': '申请单号',
  'pages.application.column.cardName': '卡产品',
  'pages.application.column.cardBin': '卡BIN',
  'pages.application.column.issueFee': '购买费用',
  'pages.application.column.status': '状态',
  'pages.application.column.cardInfo': '卡片信息',
  'pages.application.column.createdAt': '申请时间',
  'pages.application.column.action': '操作',
  'pages.application.action.detail': '详情',
  'pages.application.error.loadDetail': '加载申请详情失败',
  'pages.application.status.pending': '待处理',
  'pages.application.status.kycFailed': 'KYC失败',
  'pages.application.status.paymentFailed': '支付失败',
  'pages.application.status.paid': '已支付',
  'pages.application.status.processing': '处理中',
  'pages.application.status.shipped': '已发货',
  'pages.application.status.pendingAssign': '待分配',
  'pages.application.status.assignFailed': '分配失败',
  'pages.application.status.assigned': '待激活',
  'pages.application.status.pendingActivation': '待激活',
  'pages.application.status.activateFailed': '激活失败',
  'pages.application.status.success': '成功',
  'pages.application.status.failed': '失败',
  'pages.application.status.cancelled': '已取消',

  // 重试相关
  'pages.application.retry.payment.title': '重试支付',
  'pages.application.retry.payment.hint': '支付失败，请确保余额充足后重试。',
  'pages.application.retry.payment.button': '重新支付',
  'pages.application.retry.payment.success': '支付重试成功',
  'pages.application.retry.payment.failed': '支付重试失败',
  'pages.application.retry.kyc.title': '重新提交KYC',
  'pages.application.retry.kyc.hint':
    'KYC验证失败，请选择其他已通过的KYC身份重试。',
  'pages.application.retry.kyc.button': '使用新身份重试',
  'pages.application.retry.kyc.success': 'KYC重试成功',
  'pages.application.retry.kyc.failed': 'KYC重试失败',
  'pages.application.retry.kyc.selectKyc': '选择新的KYC身份',
  'pages.application.retry.kyc.selectKyc.required': '请选择KYC身份',
  'pages.application.retry.kyc.selectKyc.placeholder':
    '选择已通过审核的KYC身份',
  'pages.application.retry.kyc.noKyc': '没有已通过审核的KYC身份',
  'pages.application.retry.kyc.noKyc.desc': '请先在"持卡人"标签页完成KYC认证。',

  // 实体卡分配/激活重试
  'pages.physicalCard.assign.retry.title': '重新分配卡片',
  'pages.physicalCard.assign.retry.hint':
    '上次分配失败，请检查卡号后重新提交。',
  'pages.physicalCard.activate.retry.title': '重新激活卡片',
  'pages.physicalCard.activate.retry.hint':
    '上次激活失败，请检查激活码和PIN码后重新提交。',

  // 申请详情弹窗
  'pages.application.detail.title': '申请详情',
  'pages.application.detail.info': '申请信息',
  'pages.application.detail.applicationNo': '申请单号',
  'pages.application.detail.status': '状态',
  'pages.application.detail.cardProduct': '卡产品',
  'pages.application.detail.statusMessage': '状态说明',
  'pages.application.detail.feeInfo': '费用信息',
  'pages.application.detail.issueFee': '购买费用',
  'pages.application.detail.currency': '币种',
  'pages.application.detail.cardInfo': '卡片信息',
  'pages.application.detail.cardNumber': '卡号',
  'pages.application.detail.cardHolder': '持卡人',
  'pages.application.detail.timeline': '时间线',
  'pages.application.detail.createdAt': '申请时间',
  'pages.application.detail.paidAt': '支付时间',
  'pages.application.detail.completedAt': '完成时间',
  'pages.application.detail.cardType': '卡片类型',
  'pages.application.detail.shippingAddress': '收货地址',
  'pages.application.detail.recipientName': '收件人',
  'pages.application.detail.recipientPhone': '联系电话',
  'pages.application.detail.country': '国家',
  'pages.application.detail.province': '省份/州',
  'pages.application.detail.city': '城市',
  'pages.application.detail.address': '详细地址',
  'pages.application.detail.postalCode': '邮政编码',
  'pages.application.detail.shippingInfo': '物流信息',
  'pages.application.detail.shippingCompany': '物流公司',
  'pages.application.detail.trackingNumber': '物流单号',
  'pages.application.detail.shippedAt': '发货时间',
  'pages.application.step.submit': '提交',
  'pages.application.step.submitDesc': '申请已提交',
  'pages.application.step.payment': '支付',
  'pages.application.step.paymentDesc': '扣除费用',
  'pages.application.step.processing': '处理',
  'pages.application.step.processingDesc': '开卡中',
  'pages.application.step.shipping': '配送',
  'pages.application.step.shippingDesc': '卡片配送中',
  'pages.application.step.complete': '完成',
  'pages.application.step.completeDesc': '卡片就绪',

  // 持卡人管理
  'pages.cardHolder.column.name': '姓名',
  'pages.cardHolder.column.country': '国家',
  'pages.cardHolder.column.level': '等级',
  'pages.cardHolder.column.status': '状态',
  'pages.cardHolder.column.createdAt': '创建时间',
  'pages.cardHolder.column.action': '操作',
  'pages.cardHolder.status.approved': '已通过',
  'pages.cardHolder.status.rejected': '已拒绝',
  'pages.cardHolder.status.pending': '审核中',
  'pages.cardHolder.action.view': '查看',
  'pages.cardHolder.action.resubmit': '重新提交',
  'pages.cardHolder.action.create': '添加持卡人',
  'pages.cardHolder.error.loadDetail': '加载详情失败',
  // 持卡人详情
  'pages.cardHolder.detail.title': '持卡人详情',
  'pages.cardHolder.detail.status': '审核状态',
  'pages.cardHolder.detail.name': '姓名',
  'pages.cardHolder.detail.gender': '性别',
  'pages.cardHolder.detail.birthday': '出生日期',
  'pages.cardHolder.detail.country': '国家',
  'pages.cardHolder.detail.email': '邮箱',
  'pages.cardHolder.detail.phone': '电话',
  'pages.cardHolder.detail.address': '地址',
  'pages.cardHolder.detail.postCode': '邮编',
  'pages.cardHolder.detail.idType': '证件类型',
  'pages.cardHolder.detail.idNumber': '证件号码',
  'pages.cardHolder.detail.idPhotos': '证件照片',
  'pages.cardHolder.detail.idFront': '正面',
  'pages.cardHolder.detail.idBack': '背面',
  'pages.cardHolder.detail.rejectReason': '拒绝原因',
  'pages.cardHolder.gender.male': '男',
  'pages.cardHolder.gender.female': '女',
  'pages.cardHolder.idType.passport': '护照',
  'pages.cardHolder.idType.idCard': '身份证',
  // 持卡人表单
  'pages.cardHolder.form.createTitle': '添加持卡人',
  'pages.cardHolder.form.editTitle': '重新提交 KYC',
  'pages.cardHolder.form.firstName': '名',
  'pages.cardHolder.form.firstName.placeholder': '请输入名',
  'pages.cardHolder.form.lastName': '姓',
  'pages.cardHolder.form.lastName.placeholder': '请输入姓',
  'pages.cardHolder.form.name.englishOnly': '请使用英文字母（中文请使用拼音）',
  'pages.cardHolder.form.name.hint':
    '仅支持英文字母，中文用户请使用拼音（如：张三 → Zhang San）',
  'pages.cardHolder.form.gender': '性别',
  'pages.cardHolder.form.birthday': '出生日期',
  'pages.cardHolder.form.email': '邮箱',
  'pages.cardHolder.form.email.placeholder': '请输入邮箱',
  'pages.cardHolder.form.email.invalid': '请输入有效的邮箱地址',
  'pages.cardHolder.form.mobilePrefix': '区号',
  'pages.cardHolder.form.phone': '电话',
  'pages.cardHolder.form.phone.placeholder': '请输入电话',
  'pages.cardHolder.form.phone.digitsOnly': '手机号只能包含数字',
  'pages.cardHolder.form.country': '国家',
  'pages.cardHolder.form.province': '省份',
  'pages.cardHolder.form.province.placeholder': '请输入省份',
  'pages.cardHolder.form.city': '城市',
  'pages.cardHolder.form.city.placeholder': '请输入城市',
  'pages.cardHolder.form.area': '区/县',
  'pages.cardHolder.form.area.placeholder': '请输入区/县',
  'pages.cardHolder.form.postCode': '邮编',
  'pages.cardHolder.form.postCode.placeholder': '请输入邮编',
  'pages.cardHolder.form.address': '详细地址',
  'pages.cardHolder.form.address.placeholder': '请输入详细地址',
  'pages.cardHolder.form.idType': '证件类型',
  'pages.cardHolder.form.idNumber': '证件号码',
  'pages.cardHolder.form.idNumber.placeholder': '请输入证件号码',
  'pages.cardHolder.form.idFront': '证件正面照片',
  'pages.cardHolder.form.idBack': '证件背面照片',
  'pages.cardHolder.form.idFront.required': '请上传证件正面照片',
  'pages.cardHolder.form.idBack.required': '请上传证件背面照片',
  'pages.cardHolder.form.optional': '可选',
  'pages.cardHolder.form.uploaded': '已上传',
  'pages.cardHolder.form.upload.front': '上传正面',
  'pages.cardHolder.form.upload.back': '上传背面',
  'pages.cardHolder.form.upload.reupload': '重新上传',
  'pages.cardHolder.form.upload.typeError': '只能上传图片文件!',
  'pages.cardHolder.form.upload.sizeError': '图片大小不能超过 10MB!',
  'pages.cardHolder.form.upload.success': '上传成功',
  'pages.cardHolder.form.upload.failed': '上传失败',
  'pages.cardHolder.form.createSuccess': '创建成功',
  'pages.cardHolder.form.resubmitSuccess': '重新提交成功',
  'pages.cardHolder.form.submitFailed': '提交失败',

  // 我的卡片页面
  'pages.userCards.title': '我的卡片',
  'pages.userCards.list.title': '卡片列表',
  'pages.userCards.refresh': '刷新',
  'pages.userCards.empty': '暂无卡片',
  'pages.userCards.error.load': '加载卡片失败',
  // 统计信息
  'pages.userCards.stats.total': '卡片总数',
  'pages.userCards.stats.activeCards': '激活卡片',
  'pages.userCards.stats.totalBalance': '总余额',
  // 卡片状态
  'pages.userCards.status': '状态',
  'pages.userCards.status.active': '激活',
  'pages.userCards.status.assigned': '待激活',
  'pages.userCards.status.frozen': '冻结',
  'pages.userCards.status.cancelled': '已注销',
  'pages.userCards.status.expired': '已过期',
  // 卡片字段
  'pages.userCards.cardNumber': '卡号',
  'pages.userCards.holderName': '持卡人',
  'pages.userCards.expireDate': '有效期',
  'pages.userCards.balance': '余额',
  // 操作按钮
  'pages.userCards.action': '操作',
  'pages.userCards.action.detail': '详情',
  'pages.userCards.action.recharge': '充值',
  'pages.userCards.action.transactions': '流水',
  // 卡片详情弹窗
  'pages.userCards.detail.title': '卡片详情',
  'pages.userCards.detail.loading': '加载中...',
  'pages.userCards.detail.error': '加载详情失败',
  'pages.userCards.detail.basicInfo': '基本信息',
  'pages.userCards.detail.sensitiveInfo': '敏感信息',
  'pages.userCards.detail.showSensitive': '查看敏感信息',
  'pages.userCards.detail.hideSensitive': '隐藏敏感信息',
  'pages.userCards.detail.cardOrg': '卡组织',
  'pages.userCards.detail.cardBin': '卡 BIN',
  'pages.userCards.detail.createdAt': '创建时间',
  'pages.userCards.detail.cardNumber': '完整卡号',
  'pages.userCards.detail.cvv': 'CVV',
  'pages.userCards.detail.pin': 'PIN',
  'pages.userCards.detail.copy': '复制',
  'pages.userCards.detail.copySuccess': '复制成功',
  // 充值弹窗
  'pages.userCards.recharge.title': '卡片充值',
  'pages.userCards.recharge.targetCard': '目标卡片',
  'pages.userCards.recharge.currentBalance': '当前余额',
  'pages.userCards.recharge.amount': '充值金额',
  'pages.userCards.recharge.amount.placeholder': '请输入充值金额',
  'pages.userCards.recharge.amount.required': '请输入充值金额',
  'pages.userCards.recharge.amount.min': '充值金额必须大于0',
  'pages.userCards.recharge.hint': '充值将从您的 USD 账户余额中扣除',
  'pages.userCards.recharge.success': '充值成功',
  'pages.userCards.recharge.processing': '充值处理中，请稍后查看结果',
  'pages.userCards.recharge.error': '充值失败',
  'pages.userCards.recharge.newBalance': '充值后余额',
  'pages.userCards.recharge.transactionNo': '交易号',
  // 交易记录弹窗
  'pages.userCards.transactions.title': '交易记录',
  'pages.userCards.transactions.error.load': '加载交易记录失败',
  'pages.userCards.transactions.total': '共 {total} 条记录',
  'pages.userCards.transactions.column.time': '时间',
  'pages.userCards.transactions.column.type': '类型',
  'pages.userCards.transactions.column.amount': '金额',
  'pages.userCards.transactions.column.fee': '手续费',
  'pages.userCards.transactions.column.balance': '余额变动',
  'pages.userCards.transactions.column.status': '状态',
  'pages.userCards.transactions.column.transactionNo': '交易号',
  'pages.userCards.transactions.before': '交易前',
  'pages.userCards.transactions.after': '交易后',
  // 交易类型
  'pages.userCards.transactions.type.recharge': '充值',
  'pages.userCards.transactions.type.consume': '消费',
  'pages.userCards.transactions.type.refund': '退款',
  'pages.userCards.transactions.type.withdraw': '提现',
  'pages.userCards.transactions.type.fee': '手续费',
  // 交易状态
  'pages.userCards.transactions.status.pending': '处理中',
  'pages.userCards.transactions.status.success': '成功',
  'pages.userCards.transactions.status.failed': '失败',

  // 提现相关
  'pages.userCards.action.withdraw': '提现',
  'pages.userCards.withdraw.title': '卡片提现',
  'pages.userCards.withdraw.submit': '确认提现',
  'pages.userCards.withdraw.hint': '提现金额将转入您的 USD 钱包余额',
  'pages.userCards.withdraw.amount': '提现金额 (USD)',
  'pages.userCards.withdraw.amount.placeholder': '请输入提现金额',
  'pages.userCards.withdraw.amount.required': '请输入提现金额',
  'pages.userCards.withdraw.amount.min': '提现金额必须大于0',
  'pages.userCards.withdraw.amount.max': '提现金额不能超过卡片余额',
  'pages.userCards.withdraw.success': '提现成功',
  'pages.userCards.withdraw.processing': '提现请求已提交，等待确认',
  'pages.userCards.withdraw.error': '提现失败',

  // 冻结/解冻相关
  'pages.userCards.action.manage': '管理',
  'pages.userCards.action.freeze': '冻结',
  'pages.userCards.action.unfreeze': '解冻',
  'pages.userCards.freeze.unavailable': '此卡片不可冻结或解冻',
  'pages.userCards.freeze.confirm.title': '冻结卡片',
  'pages.userCards.freeze.confirm.desc':
    '冻结后卡片将无法进行交易，确定要冻结吗？',
  'pages.userCards.unfreeze.confirm.title': '解冻卡片',
  'pages.userCards.unfreeze.confirm.desc':
    '解冻后卡片将恢复正常使用，确定要解冻吗？',
  'pages.userCards.freeze.success': '卡片已冻结',
  'pages.userCards.unfreeze.success': '卡片已解冻',
  'pages.userCards.freeze.error': '操作失败',

  // 卡片详情扩展
  'pages.userCards.detail.productName': '产品名称',
  'pages.userCards.detail.status': '状态',
  'pages.userCards.detail.cardType': '卡类型',
  'pages.userCards.detail.cardType.virtual': '虚拟卡',
  'pages.userCards.detail.cardType.physical': '实体卡',
  'pages.userCards.detail.cardCurrency': '币种',
  'pages.userCards.detail.issueRegion': '发行地区',
  'pages.userCards.detail.supportedPayments': '支持支付方式',
  'pages.userCards.detail.limits': '限额设置',
  'pages.userCards.detail.yearlyLimit': '年消费限额',
  'pages.userCards.detail.feeRates': '费率设置',
  'pages.userCards.detail.fees': '费用明细',
  'pages.userCards.detail.fees.issueFee': '购买费用',
  'pages.userCards.detail.fees.annualFee': '年费',
  'pages.userCards.detail.fees.monthlyFee': '月服务费',
  'pages.userCards.detail.fees.authFee': '授权手续费',
  'pages.userCards.detail.fees.transactionFee': '交易手续费',
  'pages.userCards.detail.fees.refundFee': '退款手续费',
  'pages.userCards.detail.fees.atmWithdrawFee': 'ATM提现费',
  'pages.userCards.detail.fees.atmBalanceFee': 'ATM查询费',
  'pages.userCards.detail.fees.tdsFee': '3DS验证费',
  'pages.userCards.detail.fees.smallAmountFee': '小额交易费',
  'pages.userCards.detail.fees.chargebackFee': '拒付手续费',
  'pages.userCards.detail.fees.authFailFee': '授权失败费',
  'pages.userCards.detail.fees.crossBorderFee': '跨境手续费',
  'pages.userCards.detail.fees.specialRegionFee': '特殊地区费',

  // 充值扩展
  'pages.userCards.recharge.submit': '确认充值',
  'pages.userCards.recharge.amount.max': '超过最大充值限额',
  'pages.userCards.recharge.amount.minValue': '最小充值金额为 {min}',
  'pages.userCards.recharge.amount.maxValue': '最大充值金额为 {max}',
  'pages.userCards.recharge.limit': '充值限额',
  'pages.userCards.recharge.failed': '充值失败',
  'pages.userCards.recharge.usdBalance': 'USD 余额',
  'pages.userCards.recharge.insufficientBalance': 'USD 余额不足',

  // 费用预览
  'pages.userCards.feePreview.expectedArrival': '预计到账',
  'pages.userCards.feePreview.fee': '手续费',
  'pages.userCards.feePreview.withdrawAmount': '提现金额',
  'pages.userCards.feePreview.receive': '实际到账',

  // 复制
  'pages.userCards.copied': '{field}已复制',

  // 通用
  'pages.common.confirm': '确定',
  'pages.common.cancel': '取消',

  // 卡片中心页面
  'pages.cardCenter.title': '卡片中心',
  'pages.cardCenter.stats.accountBalance': '账户余额',
  'pages.cardCenter.stats.cardBalance': '卡片余额',
  'pages.cardCenter.stats.platformBalance': '平台余额',
  'pages.cardCenter.stats.digitalBalance': '数字资产',
  'pages.cardCenter.stats.fiatBalance': '法币资产',
  'pages.cardCenter.stats.totalCards': '卡片总数',
  'pages.cardCenter.stats.activeCards': '激活卡片',
  'pages.cardCenter.stats.active': '激活',
  'pages.cardCenter.stats.total': '总计',
  'pages.cardCenter.stats.assets': '种资产',
  'pages.cardCenter.tab.myCards': '我的卡片',
  'pages.cardCenter.tab.platformAssets': '平台资产',
  'pages.cardCenter.tab.digitalAssets': '数字资产',
  'pages.cardCenter.tab.fiatAssets': '法币资产',
  'pages.cardCenter.tab.cardHolder': '持卡人管理',
  'pages.cardCenter.tab.applications': '申请记录',
  'pages.cardCenter.tab.cardProducts': '申请卡片',
  'pages.cardCenter.tab.transactions': '交易记录',
  'pages.cardCenter.clickToDeposit': '点击充值',
  'pages.cardCenter.activeOf': '激活',
  'pages.cardCenter.cards': '张卡片',
  'pages.cardCenter.applyFirst': '申请您的第一张卡',
  'pages.cardCenter.status.realtime': '实时',
  'pages.cardCenter.status.connecting': '连接中...',
  'pages.cardCenter.frozen': '冻结',

  // 兑换功能
  'pages.swap.title': '兑换',
  'pages.swap.from': '从',
  'pages.swap.to': '至',
  'pages.swap.amount': '数量',
  'pages.swap.selectCurrency': '选择币种',
  'pages.swap.selectFrom': '请选择源币种',
  'pages.swap.selectTo': '请选择目标币种',
  'pages.swap.enterAmount': '请输入金额',
  'pages.swap.available': '可用: {amount}',
  'pages.swap.limit': '最小: {min}, 最大: {max}',
  'pages.swap.minAmount': '最小数量为 {min}',
  'pages.swap.maxAmount': '最大数量为 {max}',
  'pages.swap.insufficientBalance': '余额不足',
  'pages.swap.getQuote': '获取报价',
  'pages.swap.gettingQuote': '获取报价中...',
  'pages.swap.refresh': '刷新',
  'pages.swap.clickToRefresh': '点击刷新报价',
  'pages.swap.confirmSwap': '确认兑换',
  'pages.swap.quoteExpired': '报价已过期，刷新中...',
  'pages.swap.youWillReceive': '您将收到',
  'pages.swap.expiresIn': '有效期',
  'pages.swap.rate': '1 {from} = {price} {to}',
  'pages.swap.success': '兑换成功',
  'pages.swap.error.quote': '获取报价失败',
  'pages.swap.error.execute': '兑换失败',
  'pages.swap.noPairReverse': '不支持反向兑换',

  // 内部转账
  'pages.transfer.title': '内部转账',
  'pages.transfer.toUserId': '接收方用户ID',
  'pages.transfer.toUserId.placeholder': '请输入接收方用户ID',
  'pages.transfer.amount': '金额',
  'pages.transfer.available': '可用: {amount}',
  'pages.transfer.selectCurrency': '选择币种',
  'pages.transfer.remark': '备注 (可选)',
  'pages.transfer.remark.placeholder': '请输入转账备注',
  'pages.transfer.insufficientBalance': '余额不足',
  'pages.transfer.success': '转账成功',
  'pages.transfer.failed': '转账失败',
  'pages.transfer.enterUserId': '请输入接收方用户ID',
  'pages.transfer.enterAmount': '请输入金额',
  'pages.transfer.confirm': '确认转账',

  // 兑换管理页面
  'pages.swapManage.title': '兑换管理',
  'pages.swapManage.binanceBalances': '币安账户余额',
  'pages.swapManage.refresh': '刷新',
  'pages.swapManage.locked': '锁定',
  'pages.swapManage.clickToLoad': '点击刷新加载余额',
  'pages.swapManage.noBalances': '暂无余额数据',
  'pages.swapManage.create': '创建交易对',
  'pages.swapManage.createTitle': '创建交易对',
  'pages.swapManage.editTitle': '编辑交易对',
  'pages.swapManage.column.pair': '交易对',
  'pages.swapManage.column.feeRate': '手续费率',
  'pages.swapManage.column.minAmount': '最小金额',
  'pages.swapManage.column.maxAmount': '最大金额',
  'pages.swapManage.column.status': '状态',
  'pages.swapManage.column.action': '操作',
  'pages.swapManage.status.active': '启用',
  'pages.swapManage.status.inactive': '停用',
  'pages.swapManage.action.edit': '编辑',
  'pages.swapManage.action.delete': '删除',
  'pages.swapManage.deleteConfirm': '确定要删除这个交易对吗？',
  'pages.swapManage.form.fromSymbol': '源币种',
  'pages.swapManage.form.toSymbol': '目标币种',
  'pages.swapManage.form.feeRate': '手续费率',
  'pages.swapManage.form.feeRateHint': '(如 0.005 = 0.5%)',
  'pages.swapManage.form.minAmount': '最小金额',
  'pages.swapManage.form.maxAmount': '最大金额',
  'pages.swapManage.form.maxAmountHint': '0 表示不限制',
  'pages.swapManage.form.isActive': '启用',
  'pages.swapManage.form.pair': '交易对',
  'pages.swapManage.createSuccess': '创建成功',
  'pages.swapManage.createFailed': '创建失败',
  'pages.swapManage.updateSuccess': '更新成功',
  'pages.swapManage.updateFailed': '更新失败',
  'pages.swapManage.deleteSuccess': '删除成功',
  'pages.swapManage.deleteFailed': '删除失败',
  'pages.swapManage.loadFailed': '加载数据失败',
  'pages.swapManage.column.enableBinance': '币安交易',
  'pages.swapManage.column.dynamicMax': '动态上限',
  'pages.swapManage.column.continueOnInsufficient': '不足继续',
  'pages.swapManage.column.buffer': '缓冲',
  'pages.swapManage.form.binanceConfig': '币安配置',
  'pages.swapManage.form.enableBinance': '启用币安交易',
  'pages.swapManage.form.enableBinanceHint': '为此交易对执行真实的币安交易',
  'pages.swapManage.form.dynamicMaxAmount': '动态最大金额',
  'pages.swapManage.form.dynamicMaxAmountHint': '根据币安余额动态调整最大金额',
  'pages.swapManage.form.continueOnInsufficient': '余额不足时继续',
  'pages.swapManage.form.continueOnInsufficientHint':
    '当币安余额不足时仍继续完成用户兑换',
  'pages.swapManage.form.bufferAmount': '缓冲金额',
  'pages.swapManage.form.bufferAmountHint': '安全边际的 USDT 缓冲金额',

  // 兑换订单页面
  'pages.swapOrders.title': '兑换订单',
  'pages.swapOrders.column.id': '订单ID',
  'pages.swapOrders.column.userId': '用户ID',
  'pages.swapOrders.column.pair': '交易对',
  'pages.swapOrders.column.fromAmount': '支出金额',
  'pages.swapOrders.column.toAmount': '获得金额',
  'pages.swapOrders.column.feeAmount': '手续费',
  'pages.swapOrders.column.hedgeType': '对冲类型',
  'pages.swapOrders.column.status': '状态',
  'pages.swapOrders.column.createdAt': '创建时间',
  'pages.swapOrders.column.action': '操作',
  'pages.swapOrders.action.detail': '详情',
  'pages.swapOrders.status.pending': '处理中',
  'pages.swapOrders.status.completed': '已完成',
  'pages.swapOrders.status.failed': '失败',
  'pages.swapOrders.status.expired': '已过期',
  'pages.swapOrders.hedgeType.none': '无',
  'pages.swapOrders.hedgeType.simulated': '模拟',
  'pages.swapOrders.hedgeType.real': '真实',
  'pages.swapOrders.hedgeType.skipped': '跳过',
  'pages.swapOrders.detailTitle': '订单详情',
  'pages.swapOrders.detail.basicInfo': '基本信息',
  'pages.swapOrders.detail.feeRate': '手续费率',
  'pages.swapOrders.detail.exchangeRate': '汇率',
  'pages.swapOrders.detail.updatedAt': '更新时间',
  'pages.swapOrders.detail.errorMessage': '错误信息',
  'pages.swapOrders.detail.binanceInfo': '币安交易信息',
  'pages.swapOrders.detail.binanceOrderId': '币安订单ID',
  'pages.swapOrders.detail.binanceStatus': '币安状态',
  'pages.swapOrders.detail.binanceSymbol': '交易对',
  'pages.swapOrders.detail.binanceSide': '方向',
  'pages.swapOrders.detail.binancePrice': '成交价格',
  'pages.swapOrders.detail.binanceExecutedQty': '成交数量',
  'pages.swapOrders.detail.binanceQuoteQty': '成交金额',
  'pages.swapOrders.loadFailed': '加载数据失败',
  'pages.swapOrders.loadDetailFailed': '加载订单详情失败',

  // Physical Card - Assign
  'pages.physicalCard.assign.button': '分配卡号',
  'pages.physicalCard.assign.title': '分配实体卡',
  'pages.physicalCard.assign.hint':
    '请输入实体卡上印刷的卡号并选择持卡人身份，这是激活卡片的第一步。',
  'pages.physicalCard.assign.selectKyc': '选择持卡人',
  'pages.physicalCard.assign.selectKyc.required': '请选择持卡人身份',
  'pages.physicalCard.assign.selectKyc.placeholder': '选择已认证的KYC身份',
  'pages.physicalCard.assign.noKyc': '未找到已认证的KYC身份',
  'pages.physicalCard.assign.noKyc.desc':
    '请先在"持卡人"标签页完成KYC身份认证。',
  'pages.physicalCard.assign.cardNo': '卡号',
  'pages.physicalCard.assign.cardNo.placeholder': '输入卡片上的卡号',
  'pages.physicalCard.assign.cardNo.required': '请输入卡号',
  'pages.physicalCard.assign.cardNo.invalid': '卡号必须是13-19位数字',
  'pages.physicalCard.assign.submit': '提交分配',
  'pages.physicalCard.assign.success': '卡号分配已提交',
  'pages.physicalCard.assign.failed': '卡号分配失败',

  // Physical Card - Activate
  'pages.physicalCard.activate.button': '激活',
  'pages.physicalCard.activate.title': '激活实体卡',
  'pages.physicalCard.activate.hint':
    '请输入激活码并设置PIN码。激活码随卡片包裹一起寄送。',
  'pages.physicalCard.activate.activateCode': '激活码',
  'pages.physicalCard.activate.activateCode.placeholder': '输入激活码',
  'pages.physicalCard.activate.activateCode.required': '请输入激活码',
  'pages.physicalCard.activate.pin': 'PIN码',
  'pages.physicalCard.activate.pin.placeholder': '输入6位PIN码',
  'pages.physicalCard.activate.pin.required': '请输入PIN码',
  'pages.physicalCard.activate.pin.invalid': 'PIN码必须是6位数字',
  'pages.physicalCard.activate.submit': '激活卡片',
  'pages.physicalCard.activate.success': '卡片激活已提交',
  'pages.physicalCard.activate.failed': '卡片激活失败',

  // 返佣管理
  'pages.commissionManage.stats.totalCommissions': '累计分润总额',
  'pages.commissionManage.stats.pendingAmount': '待结算金额',
  'pages.commissionManage.stats.frozenAmount': '冻结金额',
  'pages.commissionManage.stats.claimedAmount': '已领取金额',
  'pages.commissionManage.stats.totalDirectRewards': '直推奖励总额',
  'pages.commissionManage.stats.totalLevelDiff': '极差奖励总额',
  'pages.commissionManage.stats.totalTeamBonus': '团队奖励总额',
  'pages.commissionManage.stats.totalRecords': '分润记录总数',
  'pages.commissionManage.stats.level1Count': 'L1用户数',
  'pages.commissionManage.stats.level2Count': 'L2用户数',
  'pages.commissionManage.stats.level3Count': 'L3用户数',

  'pages.commissionManage.config.title': '分润配置',
  'pages.commissionManage.config.editTitle': '编辑分润配置',
  'pages.commissionManage.config.active': '已启用',
  'pages.commissionManage.config.inactive': '已禁用',
  'pages.commissionManage.config.directRate': '直推比例',
  'pages.commissionManage.config.level1Rate': '一级极差比例',
  'pages.commissionManage.config.level2Rate': '二级极差比例',
  'pages.commissionManage.config.level3Rate': '三级比例',
  'pages.commissionManage.config.teamBonusRate': '团队奖励比例',
  'pages.commissionManage.config.rateRequired': '请输入比例',
  'pages.commissionManage.config.rateRange': '比例必须在0-100之间',
  'pages.commissionManage.config.updateSuccess': '配置更新成功',
  'pages.commissionManage.config.updateFailed': '配置更新失败',

  'pages.commissionManage.configType.card_activated': '开卡收益',
  'pages.commissionManage.configType.recharge_fee': '充值手续费',

  'pages.commissionManage.records.title': '分润记录',
  'pages.commissionManage.column.beneficiaryUid': '受益人ID',
  'pages.commissionManage.column.triggerUserId': '触发用户ID',
  'pages.commissionManage.column.rewardType': '奖励类型',
  'pages.commissionManage.column.sourceType': '来源类型',
  'pages.commissionManage.column.amount': '分润金额',
  'pages.commissionManage.column.baseAmount': '基础金额',
  'pages.commissionManage.column.rate': '比例',
  'pages.commissionManage.column.status': '状态',
  'pages.commissionManage.column.createdAt': '创建时间',
  'pages.commissionManage.column.action': '操作',

  'pages.commissionManage.rewardType.direct': '直推奖励',
  'pages.commissionManage.rewardType.level_diff': '极差奖励',
  'pages.commissionManage.rewardType.team_bonus': '团队奖励',

  'pages.commissionManage.sourceType.card_activated': '开卡',
  'pages.commissionManage.sourceType.recharge_fee': '充值手续费',
  'pages.commissionManage.sourceType.card_withdrawal': '卡提现',

  'pages.commissionManage.status.pending': '待结算',
  'pages.commissionManage.status.frozen': '冻结',
  'pages.commissionManage.status.settled': '已结算',
  'pages.commissionManage.status.claimed': '已领取',
  'pages.commissionManage.status.claiming': '领取中',

  'pages.commissionManage.filter.userId': '用户ID',
  'pages.commissionManage.filter.rewardType': '奖励类型',
  'pages.commissionManage.filter.sourceType': '来源类型',
  'pages.commissionManage.filter.status': '状态',

  'pages.commissionManage.action.view': '查看',
  'pages.commissionManage.action.edit': '编辑',
  'pages.commissionManage.action.search': '搜索',
  'pages.commissionManage.action.refresh': '刷新',

  'pages.commissionManage.detail.title': '分润记录详情',
  'pages.commissionManage.detail.frozenReason': '冻结原因',
  'pages.commissionManage.detail.updatedAt': '更新时间',
  'pages.commissionManage.detail.settledAt': '结算时间',
  'pages.commissionManage.detail.claimedAt': '领取时间',

  // 用户返佣信息 Tab
  'pages.userManage.commission.title': '返佣信息',
  'pages.userManage.commission.noData': '暂无返佣数据',
  'pages.userManage.commission.levelInfo': '等级信息',
  'pages.userManage.commission.setLevel': '设置等级',
  'pages.userManage.commission.currentLevel': '当前等级',
  'pages.userManage.commission.activatedCards': '激活卡数',
  'pages.userManage.commission.directCount': '直推人数',
  'pages.userManage.commission.teamCards': '团队激活卡',
  'pages.userManage.commission.notActivated':
    '用户未激活，需激活至少1张卡后才能领取奖励',
  'pages.userManage.commission.earningsInfo': '收益信息',
  'pages.userManage.commission.totalEarnings': '总收益',
  'pages.userManage.commission.pendingEarnings': '待领取',
  'pages.userManage.commission.frozenEarnings': '冻结中',
  'pages.userManage.commission.claimedEarnings': '已领取',
  'pages.userManage.commission.directEarnings': '直推奖励',
  'pages.userManage.commission.levelDiffEarnings': '极差奖励',
  'pages.userManage.commission.teamBonusEarnings': '团队奖励',
  'pages.userManage.commission.rateInfo': '费率信息',
  'pages.userManage.commission.customRate': '自定义费率',
  'pages.userManage.commission.setRate': '设置费率',
  'pages.userManage.commission.deleteRate': '恢复默认',
  'pages.userManage.commission.deleteRateConfirm':
    '确定删除自定义费率并恢复使用全局配置吗？',
  'pages.userManage.commission.cardRate': '购卡收益费率',
  'pages.userManage.commission.feeRate': '充值手续费费率',
  'pages.userManage.commission.directRate': '直推比例',
  'pages.userManage.commission.level1Rate': '一级极差',
  'pages.userManage.commission.level2Rate': '二级极差',
  'pages.userManage.commission.teamBonusRate': '团队奖励',
  'pages.userManage.commission.remark': '备注',
  'pages.userManage.commission.remarkPlaceholder': '如：VIP用户特殊费率',
  'pages.userManage.commission.setLevelTitle': '设置用户等级',
  'pages.userManage.commission.setLevelDesc':
    '手动设置用户等级将覆盖系统自动计算的等级。',
  'pages.userManage.commission.level1': '战略伙伴',
  'pages.userManage.commission.level2': '高级伙伴',
  'pages.userManage.commission.level3': '会员',
  'pages.userManage.commission.setRateTitle': '设置自定义费率',
  'pages.userManage.commission.setRateDesc':
    '设置自定义费率后，该用户的分润计算将优先使用这些费率。',
  'pages.userManage.commission.levelUpdateSuccess': '用户等级更新成功',
  'pages.userManage.commission.levelUpdateFailed': '用户等级更新失败',
  'pages.userManage.commission.rateUpdateSuccess': '费率设置成功',
  'pages.userManage.commission.rateUpdateFailed': '费率设置失败',
  'pages.userManage.commission.rateDeleteSuccess': '已恢复使用全局配置',
  'pages.userManage.commission.rateDeleteFailed': '删除自定义费率失败',

  // 提现配置管理
  'pages.withdrawConfig.title': '提现设置',
  'pages.withdrawConfig.create': '新建配置',
  'pages.withdrawConfig.createTitle': '新建提现配置',
  'pages.withdrawConfig.editTitle': '编辑提现配置',
  'pages.withdrawConfig.loadFailed': '加载数据失败',
  'pages.withdrawConfig.createSuccess': '创建成功',
  'pages.withdrawConfig.createFailed': '创建失败',
  'pages.withdrawConfig.updateSuccess': '更新成功',
  'pages.withdrawConfig.updateFailed': '更新失败',
  'pages.withdrawConfig.deleteSuccess': '删除成功',
  'pages.withdrawConfig.deleteFailed': '删除失败',
  'pages.withdrawConfig.deleteConfirm': '确定删除此配置吗？',
  'pages.withdrawConfig.column.currency': '币种',
  'pages.withdrawConfig.column.chain': '网络',
  'pages.withdrawConfig.column.feeType': '手续费类型',
  'pages.withdrawConfig.column.fee': '手续费',
  'pages.withdrawConfig.column.minAmount': '最小金额',
  'pages.withdrawConfig.column.maxAmount': '最大金额',
  'pages.withdrawConfig.column.status': '状态',
  'pages.withdrawConfig.column.action': '操作',
  'pages.withdrawConfig.action.edit': '编辑',
  'pages.withdrawConfig.action.delete': '删除',
  'pages.withdrawConfig.status.enabled': '启用',
  'pages.withdrawConfig.status.disabled': '禁用',
  'pages.withdrawConfig.feeType.fixed': '固定',
  'pages.withdrawConfig.feeType.percent': '百分比',
  'pages.withdrawConfig.form.currency': '币种',
  'pages.withdrawConfig.form.chain': '网络',
  'pages.withdrawConfig.form.isEnabled': '是否启用',
  'pages.withdrawConfig.form.feeType': '手续费类型',
  'pages.withdrawConfig.form.feeFixed': '固定手续费金额',
  'pages.withdrawConfig.form.feeFixedHint': '当手续费类型为固定时必填',
  'pages.withdrawConfig.form.feePercent': '百分比手续费',
  'pages.withdrawConfig.form.feePercentHint':
    '例如 0.01 = 1%，当手续费类型为百分比时必填',
  'pages.withdrawConfig.form.minAmount': '最小提现金额',
  'pages.withdrawConfig.form.maxAmount': '最大提现金额',

  // 用户提现弹窗
  'pages.withdraw.title': '提现',
  'pages.withdraw.currency': '币种',
  'pages.withdraw.selectCurrency': '选择币种',
  'pages.withdraw.chain': '网络',
  'pages.withdraw.selectChain': '选择网络',
  'pages.withdraw.address': '提现地址',
  'pages.withdraw.addressPlaceholder': '请输入提现地址',
  'pages.withdraw.addressInvalid': '地址格式不正确',
  'pages.withdraw.amount': '提现金额',
  'pages.withdraw.minAmount': '最小提现金额为 {min}',
  'pages.withdraw.maxAmount': '最大提现金额为 {max}',
  'pages.withdraw.insufficientBalance': '余额不足',
  'pages.withdraw.feeType': '手续费类型',
  'pages.withdraw.fee': '手续费',
  'pages.withdraw.limit': '限额',
  'pages.withdraw.receive': '实际到账',
  'pages.withdraw.confirm': '确认提现',
  'pages.withdraw.success': '提现申请已提交',
  'pages.withdraw.failed': '提现失败',

  // 管理员仪表盘
  'pages.dashboard.loadError': '加载数据失败',
  'pages.dashboard.refresh': '刷新',
  'pages.dashboard.sync': '同步数据',
  'pages.dashboard.sync.title': '同步运营数据',
  'pages.dashboard.sync.description':
    '将统计数据计算并保存到数据库，首次使用或数据有变动时需要执行此操作。',
  'pages.dashboard.sync.dateRange': '选择日期范围（可选）',
  'pages.dashboard.sync.startDate': '开始日期',
  'pages.dashboard.sync.endDate': '结束日期',
  'pages.dashboard.sync.hint': '留空则从最早记录同步到昨天',
  'pages.dashboard.sync.confirm': '开始同步',
  'pages.dashboard.sync.cancel': '取消',
  'pages.dashboard.sync.type': '同步类型',
  'pages.dashboard.sync.typeWallet': '钱包数据',
  'pages.dashboard.sync.typeActivity': '活跃统计',
  'pages.dashboard.sync.typeCommission': '返佣统计',
  'pages.dashboard.sync.descActivity':
    '重新计算并保存指定日期的统计数据，用于定时任务失败时补数据。',
  'pages.dashboard.sync.success': '同步成功',
  'pages.dashboard.sync.failed': '同步失败',
  'pages.dashboard.noData': '暂无数据',
  'pages.dashboard.overview.title': '数据概览',
  'pages.dashboard.overview.cumulativeDeposit': '累计充值',
  'pages.dashboard.overview.balance': '当前余额',
  'pages.dashboard.overview.todayDeposit': '今日充值',
  'pages.dashboard.overview.todayWithdraw': '今日提现',
  'pages.dashboard.overview.todayFee': '今日手续费',
  'pages.dashboard.overview.details': '详情',
  'pages.dashboard.fee.withdraw': '提现手续费',
  'pages.dashboard.fee.card': '卡片手续费',
  'pages.dashboard.fee.swap': '兑换手续费',
  'pages.dashboard.trend.title': '趋势分析',
  'pages.dashboard.trend.deposit': '充值',
  'pages.dashboard.trend.withdraw': '提现',
  'pages.dashboard.trend.withdraw_fee': '提现手续费',
  'pages.dashboard.trend.card_fee': '卡片手续费',
  'pages.dashboard.trend.swap_fee': '兑换手续费',
  'pages.dashboard.trend.balance': '余额',
  'pages.dashboard.trend.day': '按天',
  'pages.dashboard.trend.week': '按周',
  'pages.dashboard.trend.month': '按月',
  'pages.dashboard.history.title': '历史数据',
  'pages.dashboard.history.totalDeposit': '期间充值总额',
  'pages.dashboard.history.totalWithdraw': '期间提现总额',
  'pages.dashboard.history.totalFee': '期间手续费总额',
  'pages.dashboard.table.date': '日期',
  'pages.dashboard.table.deposit': '充值',
  'pages.dashboard.table.withdraw': '提现',
  'pages.dashboard.table.fee': '手续费',
  'pages.dashboard.table.balance': '余额',

  // 用户活跃数据
  'pages.dashboard.activity.title': '用户活跃数据',
  'pages.dashboard.activity.hint': '如数据缺失，请点击右上角"同步数据"补充',
  'pages.dashboard.activity.days': '天',
  'pages.dashboard.activity.avgDau': '平均日活',
  'pages.dashboard.activity.peakDau': '峰值日活',
  'pages.dashboard.activity.users': '人',
  'pages.dashboard.activity.totalOps': '总操作数',
  'pages.dashboard.activity.activeUsers': '活跃用户',
  'pages.dashboard.activity.operations': '操作次数',
  'pages.dashboard.activity.recalc': '重算统计',
  'pages.dashboard.activity.recalcTitle': '重算统计数据',
  'pages.dashboard.activity.recalcDesc':
    '手动触发重新计算并保存指定日期的统计数据。用于定时任务失败时手动补数据，或重新计算历史数据。',
  'pages.dashboard.activity.recalcType': '重算类型',
  'pages.dashboard.activity.typeAll': '全部',
  'pages.dashboard.activity.typeActivity': '活跃统计',
  'pages.dashboard.activity.typeCommission': '返佣统计',
  'pages.dashboard.activity.recalcConfirm': '开始重算',
  'pages.dashboard.activity.recalcHint': '选择需要重算的日期范围',
  'pages.dashboard.activity.selectDate': '请选择日期',
  'pages.dashboard.activity.recalcSuccess': '重算成功',
  'pages.dashboard.activity.recalcFailed': '重算失败',

  // 返佣统计
  'pages.dashboard.commission.title': '返佣统计',
  'pages.dashboard.commission.totalAmount': '总返佣',
  'pages.dashboard.commission.claimedAmount': '已领取',
  'pages.dashboard.commission.pendingAmount': '待领取',
  'pages.dashboard.commission.totalCount': '总笔数',
  'pages.dashboard.commission.claimedCount': '已领取笔数',
  'pages.dashboard.commission.pendingCount': '待领取笔数',

  // 操作日志
  'pages.operationLogs.title': '操作日志',
  'pages.operationLogs.refresh': '刷新',
  'pages.operationLogs.loadFailed': '加载数据失败',
  'pages.operationLogs.detailTitle': '日志详情',
  'pages.operationLogs.column.userId': '用户ID',
  'pages.operationLogs.column.ip': 'IP地址',
  'pages.operationLogs.column.method': '请求方法',
  'pages.operationLogs.column.path': '请求路径',
  'pages.operationLogs.column.operationType': '操作类型',
  'pages.operationLogs.column.statusCode': '状态码',
  'pages.operationLogs.column.duration': '耗时',
  'pages.operationLogs.column.isAdmin': '管理员操作',
  'pages.operationLogs.column.createdAt': '创建时间',
  'pages.operationLogs.column.dateRange': '日期范围',
  'pages.operationLogs.column.action': '操作',
  'pages.operationLogs.action.detail': '详情',
  'pages.operationLogs.isAdmin.yes': '是',
  'pages.operationLogs.isAdmin.no': '否',
  'pages.operationLogs.detail.requestDetail': '请求详情',
  'pages.operationLogs.type.login': '登录',
  'pages.operationLogs.type.bindcard': '绑定银行卡',
  'pages.operationLogs.type.bindaddress': '绑定地址',
  'pages.operationLogs.type.deposit': '充值',
  'pages.operationLogs.type.withdraw': '提现',
  'pages.operationLogs.type.swap': '兑换',
  'pages.operationLogs.type.card_apply': '申请卡',
  'pages.operationLogs.type.card_bindpayer': '绑定付款人',
  'pages.operationLogs.type.card_recharge': '卡充值',
  'pages.operationLogs.type.card_activate': '激活卡',
  'pages.operationLogs.type.asset_query': '资产查询',
  'pages.operationLogs.type.admin_config': '管理员配置',
  'pages.operationLogs.type.admin_query': '管理员查询',
  'pages.operationLogs.type.callback': '回调',
  'pages.operationLogs.type.other': '其他',

  // 操作日志 - Tab和来源
  'pages.operationLogs.tab.auth': '认证日志',
  'pages.operationLogs.tab.wallet': '钱包日志',
  'pages.operationLogs.detail.source': '日志来源',
  'pages.operationLogs.source.auth': '认证服务',
  'pages.operationLogs.source.wallet': '钱包服务',

  // 操作日志 - Auth操作类型
  'pages.operationLogs.type.logout': '登出',
  'pages.operationLogs.type.register': '注册',
  'pages.operationLogs.type.pre_login': '预登录',
  'pages.operationLogs.type.pre_register': '预注册',
  'pages.operationLogs.type.google_login': 'Google登录',
  'pages.operationLogs.type.send_email_code': '发送邮箱验证码',
  'pages.operationLogs.type.verify_email': '验证邮箱',
  'pages.operationLogs.type.send_verify_code': '发送验证码',
  'pages.operationLogs.type.verify_code': '验证码校验',
  'pages.operationLogs.type.change_password': '修改密码',
  'pages.operationLogs.type.forgot_password': '忘记密码',
  'pages.operationLogs.type.reset_password': '重置密码',
  'pages.operationLogs.type.refresh_token': '刷新令牌',
  'pages.operationLogs.type.profile_update': '更新资料',
  'pages.operationLogs.type.session_revoke': '撤销会话',
  'pages.operationLogs.type.kyc_submit': 'KYC提交',
  'pages.operationLogs.type.kyc_review': 'KYC审核',
  'pages.operationLogs.type.api_key_create': '创建API密钥',
  'pages.operationLogs.type.api_key_revoke': '撤销API密钥',
  'pages.operationLogs.type.referral_bind': '绑定推荐',
  'pages.operationLogs.type.commission_claim': '领取佣金',
  'pages.operationLogs.type.admin_action': '管理员操作',
  'pages.operationLogs.type.query': '查询',
  'pages.operationLogs.type.action': '操作',

  // 全局用户管理（global/users）
  'pages.users.title': '用户管理',
  'pages.users.refresh': '刷新',
  'pages.users.search.placeholder': '搜索邮箱、昵称或手机号',
  'pages.users.filter.statusPlaceholder': '状态筛选',
  'pages.users.filter.rolePlaceholder': '角色筛选',
  'pages.users.filter.query': '查询',
  'pages.users.pagination.totalUsers': '共 {total} 个用户',
  'pages.users.error.loadFailed': '加载失败',
  'pages.users.error.loadListFailed': '加载用户列表失败',
  'pages.users.error.getDetailFailed': '获取详情失败',
  'pages.users.error.getUserDetailFailed': '获取用户详情失败',
  'pages.users.error.updateFailed': '更新失败',
  'pages.users.error.operationFailed': '操作失败',
  'pages.users.error.statusUpdateFailed': '状态更新失败',
  'pages.users.message.rolesUpdated': '角色更新成功',
  'pages.users.message.rolesUpdateFailed': '角色更新失败',
  'pages.users.message.userBanned': '用户已封禁',
  'pages.users.message.userUnbanned': '用户已解封',

  // 状态
  'pages.users.status.active': '正常',
  'pages.users.status.disabled': '禁用',
  'pages.users.status.locked': '锁定',
  'pages.users.status.banned': '封禁',

  // 统计卡片
  'pages.users.stats.totalUsers': '总用户数',
  'pages.users.stats.activeUsers': '活跃用户',
  'pages.users.stats.verifiedUsers': '已验证',
  'pages.users.stats.bannedUsers': '已封禁',
  'pages.users.stats.todayNewUsers': '今日新增',
  'pages.users.stats.todayActiveUsers': '今日活跃',

  // 列表列
  'pages.users.column.user': '用户',
  'pages.users.column.email': '邮箱',
  'pages.users.column.phone': '手机号',
  'pages.users.column.realName': '真实姓名',
  'pages.users.column.deptName': '部门',
  'pages.users.column.positionName': '职位',
  'pages.users.column.tenantName': '租户',
  'pages.users.column.roles': '角色',
  'pages.users.column.status': '状态',
  'pages.users.column.lastLogin': '最近操作',
  'pages.users.column.action': '操作',

  // 行内操作
  'pages.users.action.detail': '详情',
  'pages.users.action.roles': '角色',
  'pages.users.action.ban': '封禁',
  'pages.users.action.unban': '解封',
  'pages.users.confirm.unban': '确定要解封该用户吗？',
  'pages.users.confirm.ban': '确定要封禁该用户吗？',

  // 详情弹窗
  'pages.users.detail.title': '用户详情',
  'pages.users.detail.id': 'ID',
  'pages.users.detail.nickname': '昵称',
  'pages.users.detail.email': '邮箱',
  'pages.users.detail.phone': '手机号',
  'pages.users.detail.status': '状态',
  'pages.users.detail.roles': '角色',
  'pages.users.detail.loginMethods': '登录方式',
  'pages.users.detail.referralCode': '推荐码',
  'pages.users.detail.lastLogin': '最近操作',
  'pages.users.detail.createdAt': '注册时间',
  'pages.users.detail.google': 'Google',
  'pages.users.detail.emailVerified': '已验证',
  'pages.users.detail.emailNotVerified': '未验证',
  'pages.users.detail.oaProfiles': 'OA 档案',
  'pages.users.detail.tenantCount': '{count} 个租户',

  // 积分管理
  'pages.users.credit.tab': '积分',
  'pages.users.credit.balance': '当前余额',
  'pages.users.credit.totalGrant': '累计充值',
  'pages.users.credit.totalSpend': '累计消费',
  'pages.users.credit.amount': '调整数额',
  'pages.users.credit.amountHint': '正数充值,负数扣除',
  'pages.users.credit.note': '备注',
  'pages.users.credit.submit': '确认',
  'pages.users.credit.done': '已调整',
  'pages.users.credit.failed': '调整失败',
  'pages.users.credit.deductConfirm': '确认扣除 {amount} Credit?',

  // 角色编辑弹窗
  'pages.users.rolesModal.title': '编辑角色 - {name}',
  'pages.users.rolesModal.operationLabel': '操作类型',
  'pages.users.rolesModal.operationRequired': '请选择操作类型',
  'pages.users.rolesModal.operation.replace': '替换（覆盖现有角色）',
  'pages.users.rolesModal.operation.assign': '添加角色',
  'pages.users.rolesModal.operation.remove': '移除角色',
  'pages.users.rolesModal.rolesLabel': '角色列表',
  'pages.users.rolesModal.rolesRequired': '请选择至少一个角色',
  'pages.users.rolesModal.rolesPlaceholder': '选择角色',

  // 平台监控页(只放基础设施类监控;用户业务任务在顶栏常驻)
  'pages.monitor.title': '平台监控',
};
